import { logGlassbox, buildGlassboxPayload } from '../glassbox.client.logger';
function _log(schemaId, eventType, eventName, params) {
  return logGlassbox(buildGlassboxPayload('Analytics', schemaId, 'Js', eventType, eventName, 'Web', params));
}
export function logAcceptAllCookies() {
  return _log(24499, 'AcceptAllCookies', 'AcceptAllCookiesWebJs');
}
export function logAcceptDiscount(params) {
  return _log(27149, 'AcceptDiscount', 'AcceptDiscountWebJs', params);
}
export function logAcceptPrivacyPolicy() {
  return _log(15700, 'AcceptPrivacyPolicy', 'AcceptPrivacyPolicyWebJs');
}
export function logAcceptTeamInvitation(params) {
  return _log(13975, 'AcceptTeamInvitation', 'AcceptTeamInvitationWebJs', params);
}
export function logAcceptTermsofService() {
  return _log(15702, 'AcceptTermsofService', 'AcceptTermsofServiceWebJs');
}
export function logAcknowledgeNotificationCenterOnboarding() {
  return _log(22222, 'AcknowledgeNotificationCenterOnboarding', 'AcknowledgeNotificationCenterOnboardingWebJs');
}
export function logActivatedAbTest(params) {
  return _log(24232, 'ActivatedAbTest', 'ActivatedAbTestWebJs', params);
}
export function logActiveFeatureSwitches(params) {
  return _log(15206, 'ActiveFeatureSwitches', 'ActiveFeatureSwitchesWebJs', params);
}
export function logAddCollaboratorFailed(params) {
  return _log(30933, 'AddCollaboratorFailed', 'AddCollaboratorFailedWebJs', params);
}
export function logAddCollaborator(params) {
  return _log(30922, 'AddCollaborator', 'AddCollaboratorWebJs', params);
}
export function logAddDocumentToFolder(params) {
  return _log(31937, 'AddDocumentToFolder', 'AddDocumentToFolderWebJs', params);
}
export function logAddFolderCollaboratorFailed(params) {
  return _log(30946, 'AddFolderCollaboratorFailed', 'AddFolderCollaboratorFailedWebJs', params);
}
export function logAddFolderCollaboratorSuccess(params) {
  return _log(22184, 'AddFolderCollaboratorSuccess', 'AddFolderCollaboratorSuccessWebJs', params);
}
export function logAddFolderCollaborator(params) {
  return _log(30942, 'AddFolderCollaborator', 'AddFolderCollaboratorWebJs', params);
}
export function logAddGramToFolder(params) {
  return _log(17308, 'AddGramToFolder', 'AddGramToFolderWebJs', params);
}
export function logAddNewIntegration(params) {
  return _log(24121, 'AddNewIntegration', 'AddNewIntegrationWebJs', params);
}
export function logAddPersonalVideoReferralInvite() {
  return _log(18366, 'AddPersonalVideoReferralInvite', 'AddPersonalVideoReferralInviteWebJs');
}
export function logAddPresentationToFolder(params) {
  return _log(14000, 'AddPresentationToFolder', 'AddPresentationToFolderWebJs', params);
}
export function logAddReferralInvitePersonalNote() {
  return _log(18362, 'AddReferralInvitePersonalNote', 'AddReferralInvitePersonalNoteWebJs');
}
export function logAddTeamMembers() {
  return _log(28001, 'AddTeamMembers', 'AddTeamMembersWebJs');
}
export function logAddedNewIntegration(params) {
  return _log(24377, 'AddedNewIntegration', 'AddedNewIntegrationWebJs', params);
}
export function logAllowBrowserNotifications() {
  return _log(14872, 'AllowBrowserNotifications', 'AllowBrowserNotificationsWebJs');
}
export function logAllowCameraFailure() {
  return _log(22684, 'AllowCameraFailure', 'AllowCameraFailureWebJs');
}
export function logAllowCameraSuccess() {
  return _log(22686, 'AllowCameraSuccess', 'AllowCameraSuccessWebJs');
}
export function logAllowToRequestBrowserNotificationsPermission() {
  return _log(14875, 'AllowToRequestBrowserNotificationsPermission', 'AllowToRequestBrowserNotificationsPermissionWebJs');
}
export function logAnsweredWorkLocationSurvey(params) {
  return _log(22840, 'AnsweredWorkLocationSurvey', 'AnsweredWorkLocationSurveyWebJs', params);
}
export function logApplyCustomVatNumber() {
  return _log(27161, 'ApplyCustomVatNumber', 'ApplyCustomVatNumberWebJs');
}
export function logApplyDateRangeDesignAnalytics(params) {
  return _log(24533, 'ApplyDateRangeDesignAnalytics', 'ApplyDateRangeDesignAnalyticsWebJs', params);
}
export function logAutoZoom(params) {
  return _log(14582, 'AutoZoom', 'AutoZoomWebJs', params);
}
export function logBackOnWelcomeScreen(params) {
  return _log(25387, 'BackOnWelcomeScreen', 'BackOnWelcomeScreenWebJs', params);
}
export function logBackToGallery(params) {
  return _log(24576, 'BackToGallery', 'BackToGalleryWebJs', params);
}
export function logBackToInvitationsFromBuyNow(params) {
  return _log(26940, 'BackToInvitationsFromBuyNow', 'BackToInvitationsFromBuyNowWebJs', params);
}
export function logBackToOutline(params) {
  return _log(31962, 'BackToOutline', 'BackToOutlineWebJs', params);
}
export function logBlockBrowserNotifications() {
  return _log(14880, 'BlockBrowserNotifications', 'BlockBrowserNotificationsWebJs');
}
export function logBrandkitError(params) {
  return _log(18868, 'BrandkitError', 'BrandkitErrorWebJs', params);
}
export function logCalloutClicked(params) {
  return _log(15214, 'CalloutClicked', 'CalloutClickedWebJs', params);
}
export function logCancelAiAdditionalOutputDownload() {
  return _log(32214, 'CancelAiAdditionalOutputDownload', 'CancelAiAdditionalOutputDownloadWebJs');
}
export function logCancelClassicToNextCopy() {
  return _log(19578, 'CancelClassicToNextCopy', 'CancelClassicToNextCopyWebJs');
}
export function logCancelPublishingEditingRestrictedPrezi(params) {
  return _log(29532, 'CancelPublishingEditingRestrictedPrezi', 'CancelPublishingEditingRestrictedPreziWebJs', params);
}
export function logCancelPurchase() {
  return _log(27309, 'CancelPurchase', 'CancelPurchaseWebJs');
}
export function logCancelSamlActivation(params) {
  return _log(16451, 'CancelSamlActivation', 'CancelSamlActivationWebJs', params);
}
export function logCancelSubscription(params) {
  return _log(26706, 'CancelSubscription', 'CancelSubscriptionWebJs', params);
}
export function logCancelTeamSubscription(params) {
  return _log(26041, 'CancelTeamSubscription', 'CancelTeamSubscriptionWebJs', params);
}
export function logCancelUnlockingRestrictedPrezi(params) {
  return _log(30107, 'CancelUnlockingRestrictedPrezi', 'CancelUnlockingRestrictedPreziWebJs', params);
}
export function logCarouselThumbnailClicked(params) {
  return _log(15111, 'CarouselThumbnailClicked', 'CarouselThumbnailClickedWebJs', params);
}
export function logChangeAccountPassword() {
  return _log(14012, 'ChangeAccountPassword', 'ChangeAccountPasswordWebJs');
}
export function logChangeCreditCardCountry() {
  return _log(27159, 'ChangeCreditCardCountry', 'ChangeCreditCardCountryWebJs');
}
export function logChangeCreditCard(params) {
  return _log(29822, 'ChangeCreditCard', 'ChangeCreditCardWebJs', params);
}
export function logChangeFrame(params) {
  return _log(22680, 'ChangeFrame', 'ChangeFrameWebJs', params);
}
export function logChangeLanguage(params) {
  return _log(31964, 'ChangeLanguage', 'ChangeLanguageWebJs', params);
}
export function logChangeOrientation(params) {
  return _log(17573, 'ChangeOrientation', 'ChangeOrientationWebJs', params);
}
export function logChangePaymentMethodFailure(params) {
  return _log(22361, 'ChangePaymentMethodFailure', 'ChangePaymentMethodFailureWebJs', params);
}
export function logChangePaymentMethodSuccess(params) {
  return _log(22359, 'ChangePaymentMethodSuccess', 'ChangePaymentMethodSuccessWebJs', params);
}
export function logChangePricingPageTab(params) {
  return _log(25519, 'ChangePricingPageTab', 'ChangePricingPageTabWebJs', params);
}
export function logChangeProfileVisibility(params) {
  return _log(14058, 'ChangeProfileVisibility', 'ChangeProfileVisibilityWebJs', params);
}
export function logChangeTeamAccess(params) {
  return _log(30952, 'ChangeTeamAccess', 'ChangeTeamAccessWebJs', params);
}
export function logChangeTeamPrivacy(params) {
  return _log(14066, 'ChangeTeamPrivacy', 'ChangeTeamPrivacyWebJs', params);
}
export function logChangeTeamTracking(params) {
  return _log(15227, 'ChangeTeamTracking', 'ChangeTeamTrackingWebJs', params);
}
export function logChangeTeamViewerIdentification(params) {
  return _log(15229, 'ChangeTeamViewerIdentification', 'ChangeTeamViewerIdentificationWebJs', params);
}
export function logChangeViewMode(params) {
  return _log(22682, 'ChangeViewMode', 'ChangeViewModeWebJs', params);
}
export function logChangedAccountInformation(params) {
  return _log(14016, 'ChangedAccountInformation', 'ChangedAccountInformationWebJs', params);
}
export function logChangedAccountPassword() {
  return _log(14018, 'ChangedAccountPassword', 'ChangedAccountPasswordWebJs');
}
export function logChangedAnalyticsTracking(params) {
  return _log(17160, 'ChangedAnalyticsTracking', 'ChangedAnalyticsTrackingWebJs', params);
}
export function logChangedCookieConsent(params) {
  return _log(24501, 'ChangedCookieConsent', 'ChangedCookieConsentWebJs', params);
}
export function logChangedFolderName(params) {
  return _log(14026, 'ChangedFolderName', 'ChangedFolderNameWebJs', params);
}
export function logChangedIntegrationEnablementState(params) {
  return _log(24379, 'ChangedIntegrationEnablementState', 'ChangedIntegrationEnablementStateWebJs', params);
}
export function logChangedPresentationTitle(params) {
  return _log(14034, 'ChangedPresentationTitle', 'ChangedPresentationTitleWebJs', params);
}
export function logChangedSessionTimeoutSetting(params) {
  return _log(22378, 'ChangedSessionTimeoutSetting', 'ChangedSessionTimeoutSettingWebJs', params);
}
export function logChangedViewLinkName(params) {
  return _log(17146, 'ChangedViewLinkName', 'ChangedViewLinkNameWebJs', params);
}
export function logChangedViewerIdentification(params) {
  return _log(17168, 'ChangedViewerIdentification', 'ChangedViewerIdentificationWebJs', params);
}
export function logClickCopyPresentationLink() {
  return _log(29607, 'ClickCopyPresentationLink', 'ClickCopyPresentationLinkWebJs');
}
export function logClickCta(params) {
  return _log(17381, 'ClickCta', 'ClickCtaWebJs', params);
}
export function logClickDashboardHome(params) {
  return _log(31725, 'ClickDashboardHome', 'ClickDashboardHomeWebJs', params);
}
export function logClickDashboardRecommendedCardCta(params) {
  return _log(18983, 'ClickDashboardRecommendedCardCta', 'ClickDashboardRecommendedCardCtaWebJs', params);
}
export function logClickExternalLink(params) {
  return _log(17615, 'ClickExternalLink', 'ClickExternalLinkWebJs', params);
}
export function logClickGetStartedOnDemoModal() {
  return _log(22674, 'ClickGetStartedOnDemoModal', 'ClickGetStartedOnDemoModalWebJs');
}
export function logClickGetStartedReferralBanner(params) {
  return _log(18433, 'ClickGetStartedReferralBanner', 'ClickGetStartedReferralBannerWebJs', params);
}
export function logClickGoToDashboardFromMobileRedirect() {
  return _log(29509, 'ClickGoToDashboardFromMobileRedirect', 'ClickGoToDashboardFromMobileRedirectWebJs');
}
export function logClickGoogleSignupOptions() {
  return _log(22934, 'ClickGoogleSignupOptions', 'ClickGoogleSignupOptionsWebJs');
}
export function logClickInAppMsg(params) {
  return _log(20484, 'ClickInAppMsg', 'ClickInAppMsgWebJs', params);
}
export function logClickMyLibraryLoadMore(params) {
  return _log(18985, 'ClickMyLibraryLoadMore', 'ClickMyLibraryLoadMoreWebJs', params);
}
export function logClickNextOnClassicToNextOnboarding(params) {
  return _log(19580, 'ClickNextOnClassicToNextOnboarding', 'ClickNextOnClassicToNextOnboardingWebJs', params);
}
export function logClickNextOnLibraryBasket() {
  return _log(17933, 'ClickNextOnLibraryBasket', 'ClickNextOnLibraryBasketWebJs');
}
export function logClickNotificationCenterMessage(params) {
  return _log(22390, 'ClickNotificationCenterMessage', 'ClickNotificationCenterMessageWebJs', params);
}
export function logClickPreviewPresentationFromMobileRedirect() {
  return _log(29507, 'ClickPreviewPresentationFromMobileRedirect', 'ClickPreviewPresentationFromMobileRedirectWebJs');
}
export function logClickPreziLogo() {
  return _log(15231, 'ClickPreziLogo', 'ClickPreziLogoWebJs');
}
export function logClickReusablePreziCard(params) {
  return _log(15622, 'ClickReusablePreziCard', 'ClickReusablePreziCardWebJs', params);
}
export function logClickSignupOnDemoModal() {
  return _log(22672, 'ClickSignupOnDemoModal', 'ClickSignupOnDemoModalWebJs');
}
export function logClickTemplateCard(params) {
  return _log(15620, 'ClickTemplateCard', 'ClickTemplateCardWebJs', params);
}
export function logClickVideoAd() {
  return _log(28675, 'ClickVideoAd', 'ClickVideoAdWebJs');
}
export function logClickVideoTag(params) {
  return _log(15698, 'ClickVideoTag', 'ClickVideoTagWebJs', params);
}
export function logClickVideoWelcomeClose() {
  return _log(15762, 'ClickVideoWelcomeClose', 'ClickVideoWelcomeCloseWebJs');
}
export function logClickVideoWelcomeLearnMore() {
  return _log(15764, 'ClickVideoWelcomeLearnMore', 'ClickVideoWelcomeLearnMoreWebJs');
}
export function logClickVideoWelcomeTerms() {
  return _log(15766, 'ClickVideoWelcomeTerms', 'ClickVideoWelcomeTermsWebJs');
}
export function logClickedContinueWithSso(params) {
  return _log(23695, 'ClickedContinueWithSso', 'ClickedContinueWithSsoWebJs', params);
}
export function logClickedCreateBrandkitCta(params) {
  return _log(23894, 'ClickedCreateBrandkitCta', 'ClickedCreateBrandkitCtaWebJs', params);
}
export function logClickedRedeemInPromoBanner() {
  return _log(31007, 'ClickedRedeemInPromoBanner', 'ClickedRedeemInPromoBannerWebJs');
}
export function logCloseAiAdditionalOutputDialog(params) {
  return _log(31740, 'CloseAiAdditionalOutputDialog', 'CloseAiAdditionalOutputDialogWebJs', params);
}
export function logCloseClassicToNextModal() {
  return _log(19582, 'CloseClassicToNextModal', 'CloseClassicToNextModalWebJs');
}
export function logCloseCollaboratorsDialog(params) {
  return _log(30961, 'CloseCollaboratorsDialog', 'CloseCollaboratorsDialogWebJs', params);
}
export function logCloseCreateAnalyticsLinkDialog() {
  return _log(14104, 'CloseCreateAnalyticsLinkDialog', 'CloseCreateAnalyticsLinkDialogWebJs');
}
export function logCloseCreditCallout(params) {
  return _log(32353, 'CloseCreditCallout', 'CloseCreditCalloutWebJs', params);
}
export function logCloseDemoModal() {
  return _log(22732, 'CloseDemoModal', 'CloseDemoModalWebJs');
}
export function logCloseDesignExportToVideoDialog(params) {
  return _log(22199, 'CloseDesignExportToVideoDialog', 'CloseDesignExportToVideoDialogWebJs', params);
}
export function logCloseDownloadDialog(params) {
  return _log(32174, 'CloseDownloadDialog', 'CloseDownloadDialogWebJs', params);
}
export function logCloseDownloadVideoAppPopup() {
  return _log(16711, 'CloseDownloadVideoAppPopup', 'CloseDownloadVideoAppPopupWebJs');
}
export function logCloseExpiredLicenseModal(params) {
  return _log(27856, 'CloseExpiredLicenseModal', 'CloseExpiredLicenseModalWebJs', params);
}
export function logCloseExportPdfDialog(params) {
  return _log(23162, 'CloseExportPdfDialog', 'CloseExportPdfDialogWebJs', params);
}
export function logCloseExportPptDialog(params) {
  return _log(14110, 'CloseExportPptDialog', 'CloseExportPptDialogWebJs', params);
}
export function logCloseFileExportDialog(params) {
  return _log(32218, 'CloseFileExportDialog', 'CloseFileExportDialogWebJs', params);
}
export function logCloseFolderCollaboratorsDialog(params) {
  return _log(15239, 'CloseFolderCollaboratorsDialog', 'CloseFolderCollaboratorsDialogWebJs', params);
}
export function logCloseFrameCollection(params) {
  return _log(31968, 'CloseFrameCollection', 'CloseFrameCollectionWebJs', params);
}
export function logCloseMinimizedDownloadView() {
  return _log(32164, 'CloseMinimizedDownloadView', 'CloseMinimizedDownloadViewWebJs');
}
export function logCloseMyLibraryExpandedView(params) {
  return _log(17069, 'CloseMyLibraryExpandedView', 'CloseMyLibraryExpandedViewWebJs', params);
}
export function logCloseNotificationCenter(params) {
  return _log(21980, 'CloseNotificationCenter', 'CloseNotificationCenterWebJs', params);
}
export function logCloseNotification() {
  return _log(14883, 'CloseNotification', 'CloseNotificationWebJs');
}
export function logClosePaywallDialog() {
  return _log(14984, 'ClosePaywallDialog', 'ClosePaywallDialogWebJs');
}
export function logClosePreziPlayerDialog(params) {
  return _log(31970, 'ClosePreziPlayerDialog', 'ClosePreziPlayerDialogWebJs', params);
}
export function logClosePrivacyDialog(params) {
  return _log(30972, 'ClosePrivacyDialog', 'ClosePrivacyDialogWebJs', params);
}
export function logCloseReferralInviteLearnMore(params) {
  return _log(18721, 'CloseReferralInviteLearnMore', 'CloseReferralInviteLearnMoreWebJs', params);
}
export function logCloseSignupFlow(params) {
  return _log(27743, 'CloseSignupFlow', 'CloseSignupFlowWebJs', params);
}
export function logCloseSupportWidget(params) {
  return _log(18690, 'CloseSupportWidget', 'CloseSupportWidgetWebJs', params);
}
export function logCloseUnsupportedBrowserEmailConfirmation() {
  return _log(17727, 'CloseUnsupportedBrowserEmailConfirmation', 'CloseUnsupportedBrowserEmailConfirmationWebJs');
}
export function logCloseUnsupportedBrowserModal() {
  return _log(17729, 'CloseUnsupportedBrowserModal', 'CloseUnsupportedBrowserModalWebJs');
}
export function logClosedDemoModal() {
  return _log(22668, 'ClosedDemoModal', 'ClosedDemoModalWebJs');
}
export function logClosedPromoBanner() {
  return _log(31009, 'ClosedPromoBanner', 'ClosedPromoBannerWebJs');
}
export function logCompletedStripeCheckout(params) {
  return _log(27705, 'CompletedStripeCheckout', 'CompletedStripeCheckoutWebJs', params);
}
export function logConfirmExportDesignToVideo(params) {
  return _log(22214, 'ConfirmExportDesignToVideo', 'ConfirmExportDesignToVideoWebJs', params);
}
export function logConfirmSamlActivation(params) {
  return _log(16453, 'ConfirmSamlActivation', 'ConfirmSamlActivationWebJs', params);
}
export function logConfirmSamlDeactivation(params) {
  return _log(16455, 'ConfirmSamlDeactivation', 'ConfirmSamlDeactivationWebJs', params);
}
export function logConfirmTeamMemberRemovalFailed(params) {
  return _log(14135, 'ConfirmTeamMemberRemovalFailed', 'ConfirmTeamMemberRemovalFailedWebJs', params);
}
export function logConfirmTeamMemberRemoval(params) {
  return _log(14133, 'ConfirmTeamMemberRemoval', 'ConfirmTeamMemberRemovalWebJs', params);
}
export function logConfirmedClassicToNextCopy(params) {
  return _log(19596, 'ConfirmedClassicToNextCopy', 'ConfirmedClassicToNextCopyWebJs', params);
}
export function logConnectSocialAccount(params) {
  return _log(29593, 'ConnectSocialAccount', 'ConnectSocialAccountWebJs', params);
}
export function logContactSales(params) {
  return _log(23938, 'ContactSales', 'ContactSalesWebJs', params);
}
export function logContactSupport() {
  return _log(16718, 'ContactSupport', 'ContactSupportWebJs');
}
export function logContactTeamAdmin(params) {
  return _log(23936, 'ContactTeamAdmin', 'ContactTeamAdminWebJs', params);
}
export function logContinueDesignToVideoOnboardingPopup() {
  return _log(20519, 'ContinueDesignToVideoOnboardingPopup', 'ContinueDesignToVideoOnboardingPopupWebJs');
}
export function logContinueWithNewIntegrationAccount(params) {
  return _log(29456, 'ContinueWithNewIntegrationAccount', 'ContinueWithNewIntegrationAccountWebJs', params);
}
export function logCopiedPresentation(params) {
  return _log(26257, 'CopiedPresentation', 'CopiedPresentationWebJs', params);
}
export function logCopyAiImage(params) {
  return _log(31972, 'CopyAiImage', 'CopyAiImageWebJs', params);
}
export function logCopyClassicToNext(params) {
  return _log(26238, 'CopyClassicToNext', 'CopyClassicToNextWebJs', params);
}
export function logCopyDesign(params) {
  return _log(26261, 'CopyDesign', 'CopyDesignWebJs', params);
}
export function logCopyDocument(params) {
  return _log(31974, 'CopyDocument', 'CopyDocumentWebJs', params);
}
export function logCopyEmbedCodeToClipboard(params) {
  return _log(30910, 'CopyEmbedCodeToClipboard', 'CopyEmbedCodeToClipboardWebJs', params);
}
export function logCopyGram(params) {
  return _log(17310, 'CopyGram', 'CopyGramWebJs', params);
}
export function logCopyPresentation(params) {
  return _log(26434, 'CopyPresentation', 'CopyPresentationWebJs', params);
}
export function logCopyPublishLink(params) {
  return _log(17354, 'CopyPublishLink', 'CopyPublishLinkWebJs', params);
}
export function logCopyReferralInviteLink(params) {
  return _log(30843, 'CopyReferralInviteLink', 'CopyReferralInviteLinkWebJs', params);
}
export function logCopyReferralLink(params) {
  return _log(30837, 'CopyReferralLink', 'CopyReferralLinkWebJs', params);
}
export function logCopyViewLink(params) {
  return _log(32386, 'CopyViewLink', 'CopyViewLinkWebJs', params);
}
export function logCreateNewBrandkit() {
  return _log(22496, 'CreateNewBrandkit', 'CreateNewBrandkitWebJs');
}
export function logCreateNewGramFromPpt(params) {
  return _log(31984, 'CreateNewGramFromPpt', 'CreateNewGramFromPptWebJs', params);
}
export function logCreateNewGramFromScratch(params) {
  return _log(31986, 'CreateNewGramFromScratch', 'CreateNewGramFromScratchWebJs', params);
}
export function logCreateNewGramFromTemplate(params) {
  return _log(31988, 'CreateNewGramFromTemplate', 'CreateNewGramFromTemplateWebJs', params);
}
export function logCreateNewGram(params) {
  return _log(31982, 'CreateNewGram', 'CreateNewGramWebJs', params);
}
export function logCreateNewPresentationFromAi(params) {
  return _log(31998, 'CreateNewPresentationFromAi', 'CreateNewPresentationFromAiWebJs', params);
}
export function logCreateNewPresentationFromFile(params) {
  return _log(32002, 'CreateNewPresentationFromFile', 'CreateNewPresentationFromFileWebJs', params);
}
export function logCreateNewPresentationFromPpt(params) {
  return _log(32006, 'CreateNewPresentationFromPpt', 'CreateNewPresentationFromPptWebJs', params);
}
export function logCreateNewPresentationFromScratch(params) {
  return _log(32012, 'CreateNewPresentationFromScratch', 'CreateNewPresentationFromScratchWebJs', params);
}
export function logCreateNewPresentationFromTemplate(params) {
  return _log(32016, 'CreateNewPresentationFromTemplate', 'CreateNewPresentationFromTemplateWebJs', params);
}
export function logCreateNewPresentation(params) {
  return _log(31992, 'CreateNewPresentation', 'CreateNewPresentationWebJs', params);
}
export function logCreateNewPresentationWithCustomBranding() {
  return _log(15005, 'CreateNewPresentationWithCustomBranding', 'CreateNewPresentationWithCustomBrandingWebJs');
}
export function logCreateNewVideoFromScratch(params) {
  return _log(32020, 'CreateNewVideoFromScratch', 'CreateNewVideoFromScratchWebJs', params);
}
export function logCreateNewVideoFromTemplate(params) {
  return _log(32022, 'CreateNewVideoFromTemplate', 'CreateNewVideoFromTemplateWebJs', params);
}
export function logCreateNewVideo(params) {
  return _log(20557, 'CreateNewVideo', 'CreateNewVideoWebJs', params);
}
export function logCreateWithAiHomepagePrompt(params) {
  return _log(29441, 'CreateWithAiHomepagePrompt', 'CreateWithAiHomepagePromptWebJs', params);
}
export function logCreateWithAiLandingPagePrompt(params) {
  return _log(27869, 'CreateWithAiLandingPagePrompt', 'CreateWithAiLandingPagePromptWebJs', params);
}
export function logCreateWithAiStudentPagePrompt(params) {
  return _log(30013, 'CreateWithAiStudentPagePrompt', 'CreateWithAiStudentPagePromptWebJs', params);
}
export function logCreatedGuestUser() {
  return _log(30855, 'CreatedGuestUser', 'CreatedGuestUserWebJs');
}
export function logCreatedNewFolder(params) {
  return _log(31978, 'CreatedNewFolder', 'CreatedNewFolderWebJs', params);
}
export function logCreatedViewLink(params) {
  return _log(17204, 'CreatedViewLink', 'CreatedViewLinkWebJs', params);
}
export function logDeactivatedViewLink(params) {
  return _log(17173, 'DeactivatedViewLink', 'DeactivatedViewLinkWebJs', params);
}
export function logDeleteAccount() {
  return _log(14150, 'DeleteAccount', 'DeleteAccountWebJs');
}
export function logDeleteAiImage(params) {
  return _log(32024, 'DeleteAiImage', 'DeleteAiImageWebJs', params);
}
export function logDeleteDocument(params) {
  return _log(32026, 'DeleteDocument', 'DeleteDocumentWebJs', params);
}
export function logDeleteFolder(params) {
  return _log(32030, 'DeleteFolder', 'DeleteFolderWebJs', params);
}
export function logDeleteGram(params) {
  return _log(17314, 'DeleteGram', 'DeleteGramWebJs', params);
}
export function logDeletedBrandkit() {
  return _log(18872, 'DeletedBrandkit', 'DeletedBrandkitWebJs');
}
export function logDeletedIntegration(params) {
  return _log(24383, 'DeletedIntegration', 'DeletedIntegrationWebJs', params);
}
export function logDeselectAudience() {
  return _log(31021, 'DeselectAudience', 'DeselectAudienceWebJs');
}
export function logDisableSamlSwitch(params) {
  return _log(16445, 'DisableSamlSwitch', 'DisableSamlSwitchWebJs', params);
}
export function logDisabledSaml(params) {
  return _log(16460, 'DisabledSaml', 'DisabledSamlWebJs', params);
}
export function logDisconnectSocialAccount(params) {
  return _log(29595, 'DisconnectSocialAccount', 'DisconnectSocialAccountWebJs', params);
}
export function logDismissInAppMsg(params) {
  return _log(20486, 'DismissInAppMsg', 'DismissInAppMsgWebJs', params);
}
export function logDisplayedAiImageGenerationErrorOnDashboard(params) {
  return _log(32034, 'DisplayedAiImageGenerationErrorOnDashboard', 'DisplayedAiImageGenerationErrorOnDashboardWebJs', params);
}
export function logDisplayedInAppMsg(params) {
  return _log(20488, 'DisplayedInAppMsg', 'DisplayedInAppMsgWebJs', params);
}
export function logDisplayedInvoices(params) {
  return _log(17769, 'DisplayedInvoices', 'DisplayedInvoicesWebJs', params);
}
export function logDisplayedNotificationCenterMessage(params) {
  return _log(22172, 'DisplayedNotificationCenterMessage', 'DisplayedNotificationCenterMessageWebJs', params);
}
export function logDisplayedNotificationCenterOnboarding() {
  return _log(22224, 'DisplayedNotificationCenterOnboarding', 'DisplayedNotificationCenterOnboardingWebJs');
}
export function logDisplayedOutstandingBalance() {
  return _log(29248, 'DisplayedOutstandingBalance', 'DisplayedOutstandingBalanceWebJs');
}
export function logDisplayedPaymentMethodChallenge() {
  return _log(23095, 'DisplayedPaymentMethodChallenge', 'DisplayedPaymentMethodChallengeWebJs');
}
export function logDisplayedPaymentMethodError(params) {
  return _log(27707, 'DisplayedPaymentMethodError', 'DisplayedPaymentMethodErrorWebJs', params);
}
export function logDowngradeExpiredLicense(params) {
  return _log(27858, 'DowngradeExpiredLicense', 'DowngradeExpiredLicenseWebJs', params);
}
export function logDownloadAiAdditionalOutputError(params) {
  return _log(31719, 'DownloadAiAdditionalOutputError', 'DownloadAiAdditionalOutputErrorWebJs', params);
}
export function logDownloadAiAdditionalOutput(params) {
  return _log(31736, 'DownloadAiAdditionalOutput', 'DownloadAiAdditionalOutputWebJs', params);
}
export function logDownloadAiImage(params) {
  return _log(32036, 'DownloadAiImage', 'DownloadAiImageWebJs', params);
}
export function logDownloadAiOutput(params) {
  return _log(31560, 'DownloadAiOutput', 'DownloadAiOutputWebJs', params);
}
export function logDownloadAnalyticsCsv(params) {
  return _log(14157, 'DownloadAnalyticsCsv', 'DownloadAnalyticsCsvWebJs', params);
}
export function logDownloadAppStarted() {
  return _log(15801, 'DownloadAppStarted', 'DownloadAppStartedWebJs');
}
export function logDownloadApp() {
  return _log(15797, 'DownloadApp', 'DownloadAppWebJs');
}
export function logDownloadChrome() {
  return _log(24075, 'DownloadChrome', 'DownloadChromeWebJs');
}
export function logDownloadDesignAnalyticsCsv(params) {
  return _log(24469, 'DownloadDesignAnalyticsCsv', 'DownloadDesignAnalyticsCsvWebJs', params);
}
export function logDownloadExportedFile(params) {
  return _log(32373, 'DownloadExportedFile', 'DownloadExportedFileWebJs', params);
}
export function logDownloadFramesAsImages(params) {
  return _log(32038, 'DownloadFramesAsImages', 'DownloadFramesAsImagesWebJs', params);
}
export function logDownloadGramProject(params) {
  return _log(21005, 'DownloadGramProject', 'DownloadGramProjectWebJs', params);
}
export function logDownloadInvoice(params) {
  return _log(17767, 'DownloadInvoice', 'DownloadInvoiceWebJs', params);
}
export function logDownloadMobileApp() {
  return _log(14164, 'DownloadMobileApp', 'DownloadMobileAppWebJs');
}
export function logDownloadMyLibraryItemAsImage(params) {
  return _log(17079, 'DownloadMyLibraryItemAsImage', 'DownloadMyLibraryItemAsImageWebJs', params);
}
export function logDownloadTeamPresentationsList(params) {
  return _log(14169, 'DownloadTeamPresentationsList', 'DownloadTeamPresentationsListWebJs', params);
}
export function logDownloadVideoApp(params) {
  return _log(32042, 'DownloadVideoApp', 'DownloadVideoAppWebJs', params);
}
export function logDownloadedAiAdditionalOutput(params) {
  return _log(31738, 'DownloadedAiAdditionalOutput', 'DownloadedAiAdditionalOutputWebJs', params);
}
export function logDownloadedExportedFile(params) {
  return _log(32222, 'DownloadedExportedFile', 'DownloadedExportedFileWebJs', params);
}
export function logEditBrandkit() {
  return _log(22494, 'EditBrandkit', 'EditBrandkitWebJs');
}
export function logEditCookieSettings() {
  return _log(24503, 'EditCookieSettings', 'EditCookieSettingsWebJs');
}
export function logEmptyTrash() {
  return _log(25033, 'EmptyTrash', 'EmptyTrashWebJs');
}
export function logEnableSamlSwitch(params) {
  return _log(16447, 'EnableSamlSwitch', 'EnableSamlSwitchWebJs', params);
}
export function logEnabledSaml(params) {
  return _log(16463, 'EnabledSaml', 'EnabledSamlWebJs', params);
}
export function logEnteredAbTestExperience(params) {
  return _log(31710, 'EnteredAbTestExperience', 'EnteredAbTestExperienceWebJs', params);
}
export function logEnteredFalseCredentials(params) {
  return _log(24381, 'EnteredFalseCredentials', 'EnteredFalseCredentialsWebJs', params);
}
export function logEstimateOccupation(params) {
  return _log(30227, 'EstimateOccupation', 'EstimateOccupationWebJs', params);
}
export function logExitWhileVideoPlayed() {
  return _log(28677, 'ExitWhileVideoPlayed', 'ExitWhileVideoPlayedWebJs');
}
export function logExploreGram() {
  return _log(17316, 'ExploreGram', 'ExploreGramWebJs');
}
export function logExplorePresentationsGallery(params) {
  return _log(32051, 'ExplorePresentationsGallery', 'ExplorePresentationsGalleryWebJs', params);
}
export function logExplorePresentations(params) {
  return _log(32047, 'ExplorePresentations', 'ExplorePresentationsWebJs', params);
}
export function logExploreVideoTemplates() {
  return _log(20588, 'ExploreVideoTemplates', 'ExploreVideoTemplatesWebJs');
}
export function logExploreVideosGallery(params) {
  return _log(32055, 'ExploreVideosGallery', 'ExploreVideosGalleryWebJs', params);
}
export function logExploreVideos(params) {
  return _log(32053, 'ExploreVideos', 'ExploreVideosWebJs', params);
}
export function logExportDesignToVideo(params) {
  return _log(20517, 'ExportDesignToVideo', 'ExportDesignToVideoWebJs', params);
}
export function logExportPdf(params) {
  return _log(31103, 'ExportPdf', 'ExportPdfWebJs', params);
}
export function logExportPpt(params) {
  return _log(14186, 'ExportPpt', 'ExportPptWebJs', params);
}
export function logExtendTrial(params) {
  return _log(24592, 'ExtendTrial', 'ExtendTrialWebJs', params);
}
export function logFailedAiMessageResponse(params) {
  return _log(31657, 'FailedAiMessageResponse', 'FailedAiMessageResponseWebJs', params);
}
export function logFailedExportedFileDownload(params) {
  return _log(32230, 'FailedExportedFileDownload', 'FailedExportedFileDownloadWebJs', params);
}
export function logFailedGeneratingAiOutput(params) {
  return _log(31558, 'FailedGeneratingAiOutput', 'FailedGeneratingAiOutputWebJs', params);
}
export function logFailedIframeLoad() {
  return _log(15140, 'FailedIframeLoad', 'FailedIframeLoadWebJs');
}
export function logFailedPaymentBuyNow(params) {
  return _log(14941, 'FailedPaymentBuyNow', 'FailedPaymentBuyNowWebJs', params);
}
export function logFailedPaymentSubmitBuyNow(params) {
  return _log(26645, 'FailedPaymentSubmitBuyNow', 'FailedPaymentSubmitBuyNowWebJs', params);
}
export function logFailedSamlLogin(params) {
  return _log(16976, 'FailedSamlLogin', 'FailedSamlLoginWebJs', params);
}
export function logFailedToCopyPresentation(params) {
  return _log(15546, 'FailedToCopyPresentation', 'FailedToCopyPresentationWebJs', params);
}
export function logFileExportError(params) {
  return _log(32234, 'FileExportError', 'FileExportErrorWebJs', params);
}
export function logFilterContent(params) {
  return _log(23735, 'FilterContent', 'FilterContentWebJs', params);
}
export function logFilterForAllProjects(params) {
  return _log(32057, 'FilterForAllProjects', 'FilterForAllProjectsWebJs', params);
}
export function logFilterForOwnership(params) {
  return _log(32059, 'FilterForOwnership', 'FilterForOwnershipWebJs', params);
}
export function logFilterPresentations(params) {
  return _log(32063, 'FilterPresentations', 'FilterPresentationsWebJs', params);
}
export function logFilterWelcomeTemplates(params) {
  return _log(20606, 'FilterWelcomeTemplates', 'FilterWelcomeTemplatesWebJs', params);
}
export function logFingerprintJsBotdDetected(params) {
  return _log(27651, 'FingerprintJsBotdDetected', 'FingerprintJsBotdDetectedWebJs', params);
}
export function logFinishedExportingPdf(params) {
  return _log(31117, 'FinishedExportingPdf', 'FinishedExportingPdfWebJs', params);
}
export function logFinishedGeneratingAiOutput(params) {
  return _log(31554, 'FinishedGeneratingAiOutput', 'FinishedGeneratingAiOutputWebJs', params);
}
export function logFirstUseCase(params) {
  return _log(23322, 'FirstUseCase', 'FirstUseCaseWebJs', params);
}
export function logFlagContent(params) {
  return _log(32067, 'FlagContent', 'FlagContentWebJs', params);
}
export function logFramesUploaded(params) {
  return _log(18087, 'FramesUploaded', 'FramesUploadedWebJs', params);
}
export function logGenerateAiImagesOnDashboard(params) {
  return _log(32069, 'GenerateAiImagesOnDashboard', 'GenerateAiImagesOnDashboardWebJs', params);
}
export function logGenerateAiPresentationContentFromAiLandingPage(params) {
  return _log(27875, 'GenerateAiPresentationContentFromAiLandingPage', 'GenerateAiPresentationContentFromAiLandingPageWebJs', params);
}
export function logGenerateAiPresentationContentFromStudentPage(params) {
  return _log(30025, 'GenerateAiPresentationContentFromStudentPage', 'GenerateAiPresentationContentFromStudentPageWebJs', params);
}
export function logGenerateAiPresentationFromHomepage(params) {
  return _log(29442, 'GenerateAiPresentationFromHomepage', 'GenerateAiPresentationFromHomepageWebJs', params);
}
export function logGenerateAiPresentationOutline(params) {
  return _log(31458, 'GenerateAiPresentationOutline', 'GenerateAiPresentationOutlineWebJs', params);
}
export function logGenerateAiPresentation(params) {
  return _log(32360, 'GenerateAiPresentation', 'GenerateAiPresentationWebJs', params);
}
export function logGetUnlimitedAi(params) {
  return _log(32349, 'GetUnlimitedAi', 'GetUnlimitedAiWebJs', params);
}
export function logHidRotateOverlay() {
  return _log(29530, 'HidRotateOverlay', 'HidRotateOverlayWebJs');
}
export function logHideQrCodePresenting(params) {
  return _log(31704, 'HideQrCodePresenting', 'HideQrCodePresentingWebJs', params);
}
export function logImageSearchMicropaymentFormClosed() {
  return _log(27474, 'ImageSearchMicropaymentFormClosed', 'ImageSearchMicropaymentFormClosedWebJs');
}
export function logImageSearchMicropaymentValuePropositionPageClosed() {
  return _log(27476, 'ImageSearchMicropaymentValuePropositionPageClosed', 'ImageSearchMicropaymentValuePropositionPageClosedWebJs');
}
export function logImpressionViewableEvent() {
  return _log(29376, 'ImpressionViewableEvent', 'ImpressionViewableEventWebJs');
}
export function logInviteNewTeamMember(params) {
  return _log(23362, 'InviteNewTeamMember', 'InviteNewTeamMemberWebJs', params);
}
export function logInvitedTeamMember(params) {
  return _log(14210, 'InvitedTeamMember', 'InvitedTeamMemberWebJs', params);
}
export function logKeptDiscount(params) {
  return _log(27143, 'KeptDiscount', 'KeptDiscountWebJs', params);
}
export function logLearnMoreAboutViewToVideo(params) {
  return _log(32071, 'LearnMoreAboutViewToVideo', 'LearnMoreAboutViewToVideoWebJs', params);
}
export function logLeaveFullScreen(params) {
  return _log(17402, 'LeaveFullScreen', 'LeaveFullScreenWebJs', params);
}
export function logLikePresentationPage(params) {
  return _log(15839, 'LikePresentationPage', 'LikePresentationPageWebJs', params);
}
export function logLikePublishPage(params) {
  return _log(17360, 'LikePublishPage', 'LikePublishPageWebJs', params);
}
export function logLoadAllViewLinks(params) {
  return _log(15284, 'LoadAllViewLinks', 'LoadAllViewLinksWebJs', params);
}
export function logLoadDetailedView(params) {
  return _log(14595, 'LoadDetailedView', 'LoadDetailedViewWebJs', params);
}
export function logLoadEditor(params) {
  return _log(14548, 'LoadEditor', 'LoadEditorWebJs', params);
}
export function logLoadPreziCard(params) {
  return _log(15518, 'LoadPreziCard', 'LoadPreziCardWebJs', params);
}
export function logLoadPrezi(params) {
  return _log(14283, 'LoadPrezi', 'LoadPreziWebJs', params);
}
export function logLoadPublicViewPage(params) {
  return _log(13881, 'LoadPublicViewPage', 'LoadPublicViewPageWebJs', params);
}
export function logLoadedAccountSettings() {
  return _log(14232, 'LoadedAccountSettings', 'LoadedAccountSettingsWebJs');
}
export function logLoadedAiPresentationContentFromHomepage(params) {
  return _log(29443, 'LoadedAiPresentationContentFromHomepage', 'LoadedAiPresentationContentFromHomepageWebJs', params);
}
export function logLoadedAiPresentationContentFromStudentPage(params) {
  return _log(30021, 'LoadedAiPresentationContentFromStudentPage', 'LoadedAiPresentationContentFromStudentPageWebJs', params);
}
export function logLoadedAiPresentationFromAiLandingPage() {
  return _log(27871, 'LoadedAiPresentationFromAiLandingPage', 'LoadedAiPresentationFromAiLandingPageWebJs');
}
export function logLoadedBillingPage(params) {
  return _log(18141, 'LoadedBillingPage', 'LoadedBillingPageWebJs', params);
}
export function logLoadedBlogPage() {
  return _log(15793, 'LoadedBlogPage', 'LoadedBlogPageWebJs');
}
export function logLoadedBrandkit(params) {
  return _log(18876, 'LoadedBrandkit', 'LoadedBrandkitWebJs', params);
}
export function logLoadedBrowserNotificationsDialog() {
  return _log(14887, 'LoadedBrowserNotificationsDialog', 'LoadedBrowserNotificationsDialogWebJs');
}
export function logLoadedBuyNowPage(params) {
  return _log(27139, 'LoadedBuyNowPage', 'LoadedBuyNowPageWebJs', params);
}
export function logLoadedContactSalesCalendar(params) {
  return _log(24055, 'LoadedContactSalesCalendar', 'LoadedContactSalesCalendarWebJs', params);
}
export function logLoadedContactSalesForm(params) {
  return _log(23236, 'LoadedContactSalesForm', 'LoadedContactSalesFormWebJs', params);
}
export function logLoadedCookieBanner() {
  return _log(24505, 'LoadedCookieBanner', 'LoadedCookieBannerWebJs');
}
export function logLoadedCopyFailedDialog(params) {
  return _log(15028, 'LoadedCopyFailedDialog', 'LoadedCopyFailedDialogWebJs', params);
}
export function logLoadedCopyInProgressDialog(params) {
  return _log(15034, 'LoadedCopyInProgressDialog', 'LoadedCopyInProgressDialogWebJs', params);
}
export function logLoadedCreateTeam(params) {
  return _log(32073, 'LoadedCreateTeam', 'LoadedCreateTeamWebJs', params);
}
export function logLoadedCreditCallout(params) {
  return _log(32333, 'LoadedCreditCallout', 'LoadedCreditCalloutWebJs', params);
}
export function logLoadedDashboard(params) {
  return _log(25523, 'LoadedDashboard', 'LoadedDashboardWebJs', params);
}
export function logLoadedDetailedView(params) {
  return _log(14237, 'LoadedDetailedView', 'LoadedDetailedViewWebJs', params);
}
export function logLoadedDownloadAppDialog() {
  return _log(14245, 'LoadedDownloadAppDialog', 'LoadedDownloadAppDialogWebJs');
}
export function logLoadedDownloadVideoAppPopup() {
  return _log(22633, 'LoadedDownloadVideoAppPopup', 'LoadedDownloadVideoAppPopupWebJs');
}
export function logLoadedDownloadVideoAppWelcomeScreen() {
  return _log(20614, 'LoadedDownloadVideoAppWelcomeScreen', 'LoadedDownloadVideoAppWelcomeScreenWebJs');
}
export function logLoadedEditor(params) {
  return _log(29446, 'LoadedEditor', 'LoadedEditorWebJs', params);
}
export function logLoadedExpiredLicenseModal(params) {
  return _log(27860, 'LoadedExpiredLicenseModal', 'LoadedExpiredLicenseModalWebJs', params);
}
export function logLoadedFolder(params) {
  return _log(14257, 'LoadedFolder', 'LoadedFolderWebJs', params);
}
export function logLoadedFrameCollection(params) {
  return _log(32075, 'LoadedFrameCollection', 'LoadedFrameCollectionWebJs', params);
}
export function logLoadedGuestSignupPage() {
  return _log(30858, 'LoadedGuestSignupPage', 'LoadedGuestSignupPageWebJs');
}
export function logLoadedIntegrationArea(params) {
  return _log(24123, 'LoadedIntegrationArea', 'LoadedIntegrationAreaWebJs', params);
}
export function logLoadedInviteTeamMember(params) {
  return _log(32077, 'LoadedInviteTeamMember', 'LoadedInviteTeamMemberWebJs', params);
}
export function logLoadedLivePreziFollowPage(params) {
  return _log(14262, 'LoadedLivePreziFollowPage', 'LoadedLivePreziFollowPageWebJs', params);
}
export function logLoadedMissingPaymentModal() {
  return _log(29820, 'LoadedMissingPaymentModal', 'LoadedMissingPaymentModalWebJs');
}
export function logLoadedMyLibrary(params) {
  return _log(17698, 'LoadedMyLibrary', 'LoadedMyLibraryWebJs', params);
}
export function logLoadedNotificationCenterFirstPage(params) {
  return _log(22174, 'LoadedNotificationCenterFirstPage', 'LoadedNotificationCenterFirstPageWebJs', params);
}
export function logLoadedNotification(params) {
  return _log(14889, 'LoadedNotification', 'LoadedNotificationWebJs', params);
}
export function logLoadedPage(params) {
  return _log(30503, 'LoadedPage', 'LoadedPageWebJs', params);
}
export function logLoadedPaymentMethodPage() {
  return _log(22355, 'LoadedPaymentMethodPage', 'LoadedPaymentMethodPageWebJs');
}
export function logLoadedPaywallCta(params) {
  return _log(31613, 'LoadedPaywallCta', 'LoadedPaywallCtaWebJs', params);
}
export function logLoadedPaywallDialog(params) {
  return _log(30299, 'LoadedPaywallDialog', 'LoadedPaywallDialogWebJs', params);
}
export function logLoadedPresentationPicker(params) {
  return _log(18419, 'LoadedPresentationPicker', 'LoadedPresentationPickerWebJs', params);
}
export function logLoadedPreziCard(params) {
  return _log(15296, 'LoadedPreziCard', 'LoadedPreziCardWebJs', params);
}
export function logLoadedPrezi(params) {
  return _log(15294, 'LoadedPrezi', 'LoadedPreziWebJs', params);
}
export function logLoadedPricingPage(params) {
  return _log(30852, 'LoadedPricingPage', 'LoadedPricingPageWebJs', params);
}
export function logLoadedProductSelectorDialog() {
  return _log(23290, 'LoadedProductSelectorDialog', 'LoadedProductSelectorDialogWebJs');
}
export function logLoadedPublicPublishPage(params) {
  return _log(20262, 'LoadedPublicPublishPage', 'LoadedPublicPublishPageWebJs', params);
}
export function logLoadedPublicViewPage(params) {
  return _log(15298, 'LoadedPublicViewPage', 'LoadedPublicViewPageWebJs', params);
}
export function logLoadedPublicViewPageWithGoogleAd() {
  return _log(29246, 'LoadedPublicViewPageWithGoogleAd', 'LoadedPublicViewPageWithGoogleAdWebJs');
}
export function logLoadedRecordPresentationWelcomeScreen() {
  return _log(20616, 'LoadedRecordPresentationWelcomeScreen', 'LoadedRecordPresentationWelcomeScreenWebJs');
}
export function logLoadedReferralDashboard(params) {
  return _log(18348, 'LoadedReferralDashboard', 'LoadedReferralDashboardWebJs', params);
}
export function logLoadedReferralInviteBanner(params) {
  return _log(18406, 'LoadedReferralInviteBanner', 'LoadedReferralInviteBannerWebJs', params);
}
export function logLoadedReferralInviteButton(params) {
  return _log(18981, 'LoadedReferralInviteButton', 'LoadedReferralInviteButtonWebJs', params);
}
export function logLoadedReferralLanding(params) {
  return _log(30846, 'LoadedReferralLanding', 'LoadedReferralLandingWebJs', params);
}
export function logLoadedReferralLeaderboard(params) {
  return _log(18370, 'LoadedReferralLeaderboard', 'LoadedReferralLeaderboardWebJs', params);
}
export function logLoadedReferralSignup(params) {
  return _log(18667, 'LoadedReferralSignup', 'LoadedReferralSignupWebJs', params);
}
export function logLoadedSegmentationDialog() {
  return _log(15300, 'LoadedSegmentationDialog', 'LoadedSegmentationDialogWebJs');
}
export function logLoadedSignupFlow(params) {
  return _log(27709, 'LoadedSignupFlow', 'LoadedSignupFlowWebJs', params);
}
export function logLoadedSignupPage() {
  return _log(30849, 'LoadedSignupPage', 'LoadedSignupPageWebJs');
}
export function logLoadedStartFromTemplateOrPrompt() {
  return _log(27837, 'LoadedStartFromTemplateOrPrompt', 'LoadedStartFromTemplateOrPromptWebJs');
}
export function logLoadedSubSegmentationDialog() {
  return _log(20582, 'LoadedSubSegmentationDialog', 'LoadedSubSegmentationDialogWebJs');
}
export function logLoadedTeamInvitationDialog(params) {
  return _log(15302, 'LoadedTeamInvitationDialog', 'LoadedTeamInvitationDialogWebJs', params);
}
export function logLoadedTeamMemberList(params) {
  return _log(14272, 'LoadedTeamMemberList', 'LoadedTeamMemberListWebJs', params);
}
export function logLoadedTeamMemberSignupPage() {
  return _log(15304, 'LoadedTeamMemberSignupPage', 'LoadedTeamMemberSignupPageWebJs');
}
export function logLoadedTemplateList(params) {
  return _log(16389, 'LoadedTemplateList', 'LoadedTemplateListWebJs', params);
}
export function logLoadedTranscript(params) {
  return _log(15308, 'LoadedTranscript', 'LoadedTranscriptWebJs', params);
}
export function logLoadedUrgencySelector() {
  return _log(27649, 'LoadedUrgencySelector', 'LoadedUrgencySelectorWebJs');
}
export function logLoadedVideoAd() {
  return _log(28669, 'LoadedVideoAd', 'LoadedVideoAdWebJs');
}
export function logLoadedViewerIdentificationForm(params) {
  return _log(15515, 'LoadedViewerIdentificationForm', 'LoadedViewerIdentificationFormWebJs', params);
}
export function logLoadedViewer(params) {
  return _log(15316, 'LoadedViewer', 'LoadedViewerWebJs', params);
}
export function logLoadedWelcomeBack(params) {
  return _log(30333, 'LoadedWelcomeBack', 'LoadedWelcomeBackWebJs', params);
}
export function logLoadedWelcomeDeliverySelection() {
  return _log(20612, 'LoadedWelcomeDeliverySelection', 'LoadedWelcomeDeliverySelectionWebJs');
}
export function logLoadedWelcomePresentContentOptions() {
  return _log(20618, 'LoadedWelcomePresentContentOptions', 'LoadedWelcomePresentContentOptionsWebJs');
}
export function logLoadedWelcomeTemplateSelector() {
  return _log(20596, 'LoadedWelcomeTemplateSelector', 'LoadedWelcomeTemplateSelectorWebJs');
}
export function logLoadedWelcomeVideoSelector() {
  return _log(20584, 'LoadedWelcomeVideoSelector', 'LoadedWelcomeVideoSelectorWebJs');
}
export function logLoadedWowDownloadPage() {
  return _log(22085, 'LoadedWowDownloadPage', 'LoadedWowDownloadPageWebJs');
}
export function logLoggedChatConversation(params) {
  return _log(31666, 'LoggedChatConversation', 'LoggedChatConversationWebJs', params);
}
export function logLoggedChatFeedback(params) {
  return _log(32248, 'LoggedChatFeedback', 'LoggedChatFeedbackWebJs', params);
}
export function logLoggedIn(params) {
  return _log(29591, 'LoggedIn', 'LoggedInWebJs', params);
}
export function logLogin(params) {
  return _log(29601, 'Login', 'LoginWebJs', params);
}
export function logLogout() {
  return _log(25858, 'Logout', 'LogoutWebJs');
}
export function logMakeAdmin(params) {
  return _log(14296, 'MakeAdmin', 'MakeAdminWebJs', params);
}
export function logMarkAllNotificationsAsRead() {
  return _log(21984, 'MarkAllNotificationsAsRead', 'MarkAllNotificationsAsReadWebJs');
}
export function logMarkNotificationAsRead(params) {
  return _log(22392, 'MarkNotificationAsRead', 'MarkNotificationAsReadWebJs', params);
}
export function logMicrotransactionMobilePaymentSuccess(params) {
  return _log(27445, 'MicrotransactionMobilePaymentSuccess', 'MicrotransactionMobilePaymentSuccessWebJs', params);
}
export function logMismatchedIntegrationUserAssociation(params) {
  return _log(29461, 'MismatchedIntegrationUserAssociation', 'MismatchedIntegrationUserAssociationWebJs', params);
}
export function logMobilePaymentAbandoned(params) {
  return _log(27447, 'MobilePaymentAbandoned', 'MobilePaymentAbandonedWebJs', params);
}
export function logMobilePaymentStarted(params) {
  return _log(27449, 'MobilePaymentStarted', 'MobilePaymentStartedWebJs', params);
}
export function logMobilePaymentSuccess(params) {
  return _log(27451, 'MobilePaymentSuccess', 'MobilePaymentSuccessWebJs', params);
}
export function logMoveDocumentToTrash(params) {
  return _log(32079, 'MoveDocumentToTrash', 'MoveDocumentToTrashWebJs', params);
}
export function logNavigatePresentationStructureDesignVideoPreview(params) {
  return _log(22209, 'NavigatePresentationStructureDesignVideoPreview', 'NavigatePresentationStructureDesignVideoPreviewWebJs', params);
}
export function logNavigatePrezi(params) {
  return _log(32423, 'NavigatePrezi', 'NavigatePreziWebJs', params);
}
export function logNavigateUnifiedProjectPicker(params) {
  return _log(32081, 'NavigateUnifiedProjectPicker', 'NavigateUnifiedProjectPickerWebJs', params);
}
export function logNewSession() {
  return _log(15331, 'NewSession', 'NewSessionWebJs');
}
export function logOfferedDiscount(params) {
  return _log(27152, 'OfferedDiscount', 'OfferedDiscountWebJs', params);
}
export function logOpenAccountSettings(params) {
  return _log(32087, 'OpenAccountSettings', 'OpenAccountSettingsWebJs', params);
}
export function logOpenAdminConsole(params) {
  return _log(32091, 'OpenAdminConsole', 'OpenAdminConsoleWebJs', params);
}
export function logOpenAiAdditionalOutputDialog(params) {
  return _log(32093, 'OpenAiAdditionalOutputDialog', 'OpenAiAdditionalOutputDialogWebJs', params);
}
export function logOpenAiImages(params) {
  return _log(32095, 'OpenAiImages', 'OpenAiImagesWebJs', params);
}
export function logOpenAllViewLinks(params) {
  return _log(15347, 'OpenAllViewLinks', 'OpenAllViewLinksWebJs', params);
}
export function logOpenAnalyticsDetailsPage(params) {
  return _log(15353, 'OpenAnalyticsDetailsPage', 'OpenAnalyticsDetailsPageWebJs', params);
}
export function logOpenAnalyticsLinkSettings(params) {
  return _log(15355, 'OpenAnalyticsLinkSettings', 'OpenAnalyticsLinkSettingsWebJs', params);
}
export function logOpenAnalytics() {
  return _log(15349, 'OpenAnalytics', 'OpenAnalyticsWebJs');
}
export function logOpenArticle(params) {
  return _log(16422, 'OpenArticle', 'OpenArticleWebJs', params);
}
export function logOpenAudienceModal() {
  return _log(31023, 'OpenAudienceModal', 'OpenAudienceModalWebJs');
}
export function logOpenCameraSelector() {
  return _log(22734, 'OpenCameraSelector', 'OpenCameraSelectorWebJs');
}
export function logOpenCollaboratorsDialog(params) {
  return _log(14605, 'OpenCollaboratorsDialog', 'OpenCollaboratorsDialogWebJs', params);
}
export function logOpenCompanyLeaderboard(params) {
  return _log(14323, 'OpenCompanyLeaderboard', 'OpenCompanyLeaderboardWebJs', params);
}
export function logOpenCraftEditor() {
  return _log(32438, 'OpenCraftEditor', 'OpenCraftEditorWebJs');
}
export function logOpenCreateAnalyticsLinkDialog() {
  return _log(14325, 'OpenCreateAnalyticsLinkDialog', 'OpenCreateAnalyticsLinkDialogWebJs');
}
export function logOpenCreateNewDropdown(params) {
  return _log(32097, 'OpenCreateNewDropdown', 'OpenCreateNewDropdownWebJs', params);
}
export function logOpenCreateViewLinkDialog(params) {
  return _log(17210, 'OpenCreateViewLinkDialog', 'OpenCreateViewLinkDialogWebJs', params);
}
export function logOpenCreditBalanceModal(params) {
  return _log(30527, 'OpenCreditBalanceModal', 'OpenCreditBalanceModalWebJs', params);
}
export function logOpenDashboardCardContextMenu(params) {
  return _log(18987, 'OpenDashboardCardContextMenu', 'OpenDashboardCardContextMenuWebJs', params);
}
export function logOpenDashboard(params) {
  return _log(20832, 'OpenDashboard', 'OpenDashboardWebJs', params);
}
export function logOpenDeleteFolderDialog(params) {
  return _log(14328, 'OpenDeleteFolderDialog', 'OpenDeleteFolderDialogWebJs', params);
}
export function logOpenDeletePresentationDialog(params) {
  return _log(14655, 'OpenDeletePresentationDialog', 'OpenDeletePresentationDialogWebJs', params);
}
export function logOpenDesignAnalyticsDatePicker(params) {
  return _log(24473, 'OpenDesignAnalyticsDatePicker', 'OpenDesignAnalyticsDatePickerWebJs', params);
}
export function logOpenDesignAnalyticsDetailsPage(params) {
  return _log(24465, 'OpenDesignAnalyticsDetailsPage', 'OpenDesignAnalyticsDetailsPageWebJs', params);
}
export function logOpenDesignAnalytics() {
  return _log(24463, 'OpenDesignAnalytics', 'OpenDesignAnalyticsWebJs');
}
export function logOpenDetailedView(params) {
  return _log(15524, 'OpenDetailedView', 'OpenDetailedViewWebJs', params);
}
export function logOpenDocumentDetails(params) {
  return _log(32099, 'OpenDocumentDetails', 'OpenDocumentDetailsWebJs', params);
}
export function logOpenDocumentToEdit(params) {
  return _log(32376, 'OpenDocumentToEdit', 'OpenDocumentToEditWebJs', params);
}
export function logOpenDocumentToView(params) {
  return _log(32379, 'OpenDocumentToView', 'OpenDocumentToViewWebJs', params);
}
export function logOpenDownloadCenter(params) {
  return _log(23648, 'OpenDownloadCenter', 'OpenDownloadCenterWebJs', params);
}
export function logOpenDownloadPresentationDialog(params) {
  return _log(23189, 'OpenDownloadPresentationDialog', 'OpenDownloadPresentationDialogWebJs', params);
}
export function logOpenDownloadPreziAppsModal(params) {
  return _log(32101, 'OpenDownloadPreziAppsModal', 'OpenDownloadPreziAppsModalWebJs', params);
}
export function logOpenEditor(params) {
  return _log(14638, 'OpenEditor', 'OpenEditorWebJs', params);
}
export function logOpenEmbedShare(params) {
  return _log(30914, 'OpenEmbedShare', 'OpenEmbedShareWebJs', params);
}
export function logOpenExpandedViewSource(params) {
  return _log(23745, 'OpenExpandedViewSource', 'OpenExpandedViewSourceWebJs', params);
}
export function logOpenExportPdfDialog(params) {
  return _log(23140, 'OpenExportPdfDialog', 'OpenExportPdfDialogWebJs', params);
}
export function logOpenExportPptDialog(params) {
  return _log(14335, 'OpenExportPptDialog', 'OpenExportPptDialogWebJs', params);
}
export function logOpenExportedPdf(params) {
  return _log(31123, 'OpenExportedPdf', 'OpenExportedPdfWebJs', params);
}
export function logOpenFileExportDialog(params) {
  return _log(32238, 'OpenFileExportDialog', 'OpenFileExportDialogWebJs', params);
}
export function logOpenFolderCollaboratorsDialog(params) {
  return _log(15357, 'OpenFolderCollaboratorsDialog', 'OpenFolderCollaboratorsDialogWebJs', params);
}
export function logOpenFolderListForPresentation(params) {
  return _log(15363, 'OpenFolderListForPresentation', 'OpenFolderListForPresentationWebJs', params);
}
export function logOpenFolder(params) {
  return _log(32111, 'OpenFolder', 'OpenFolderWebJs', params);
}
export function logOpenFrameCollection(params) {
  return _log(32117, 'OpenFrameCollection', 'OpenFrameCollectionWebJs', params);
}
export function logOpenFrame(params) {
  return _log(32115, 'OpenFrame', 'OpenFrameWebJs', params);
}
export function logOpenHelpCenterPage() {
  return _log(18332, 'OpenHelpCenterPage', 'OpenHelpCenterPageWebJs');
}
export function logOpenHelpMenu(params) {
  return _log(32121, 'OpenHelpMenu', 'OpenHelpMenuWebJs', params);
}
export function logOpenHyperlink(params) {
  return _log(29152, 'OpenHyperlink', 'OpenHyperlinkWebJs', params);
}
export function logOpenIntercom() {
  return _log(14349, 'OpenIntercom', 'OpenIntercomWebJs');
}
export function logOpenInvoices(params) {
  return _log(17765, 'OpenInvoices', 'OpenInvoicesWebJs', params);
}
export function logOpenKnowledgeBase() {
  return _log(14351, 'OpenKnowledgeBase', 'OpenKnowledgeBaseWebJs');
}
export function logOpenLanguageChooser() {
  return _log(14357, 'OpenLanguageChooser', 'OpenLanguageChooserWebJs');
}
export function logOpenLearnMoreBrandkit() {
  return _log(18880, 'OpenLearnMoreBrandkit', 'OpenLearnMoreBrandkitWebJs');
}
export function logOpenLearnPage() {
  return _log(15479, 'OpenLearnPage', 'OpenLearnPageWebJs');
}
export function logOpenLicenseSettings() {
  return _log(14359, 'OpenLicenseSettings', 'OpenLicenseSettingsWebJs');
}
export function logOpenLivePreziDialog(params) {
  return _log(14644, 'OpenLivePreziDialog', 'OpenLivePreziDialogWebJs', params);
}
export function logOpenMobileApp() {
  return _log(15390, 'OpenMobileApp', 'OpenMobileAppWebJs');
}
export function logOpenMobileAppsPage() {
  return _log(14361, 'OpenMobileAppsPage', 'OpenMobileAppsPageWebJs');
}
export function logOpenMyLibraryExpandedView(params) {
  return _log(17067, 'OpenMyLibraryExpandedView', 'OpenMyLibraryExpandedViewWebJs', params);
}
export function logOpenNotificationCenter(params) {
  return _log(21978, 'OpenNotificationCenter', 'OpenNotificationCenterWebJs', params);
}
export function logOpenNotification() {
  return _log(14891, 'OpenNotification', 'OpenNotificationWebJs');
}
export function logOpenOnboardingPreziCardMenu(params) {
  return _log(15165, 'OpenOnboardingPreziCardMenu', 'OpenOnboardingPreziCardMenuWebJs', params);
}
export function logOpenOnboardingPreziDetailedView(params) {
  return _log(15395, 'OpenOnboardingPreziDetailedView', 'OpenOnboardingPreziDetailedViewWebJs', params);
}
export function logOpenOnboardingPreziToEdit(params) {
  return _log(15171, 'OpenOnboardingPreziToEdit', 'OpenOnboardingPreziToEditWebJs', params);
}
export function logOpenOnboardingPreziToPresent(params) {
  return _log(15174, 'OpenOnboardingPreziToPresent', 'OpenOnboardingPreziToPresentWebJs', params);
}
export function logOpenOnboardingVideo(params) {
  return _log(15403, 'OpenOnboardingVideo', 'OpenOnboardingVideoWebJs', params);
}
export function logOpenPresentationCardMenu(params) {
  return _log(14376, 'OpenPresentationCardMenu', 'OpenPresentationCardMenuWebJs', params);
}
export function logOpenPresentationFilter() {
  return _log(14379, 'OpenPresentationFilter', 'OpenPresentationFilterWebJs');
}
export function logOpenPresenterView(params) {
  return _log(27173, 'OpenPresenterView', 'OpenPresenterViewWebJs', params);
}
export function logOpenPreziCard(params) {
  return _log(15000, 'OpenPreziCard', 'OpenPreziCardWebJs', params);
}
export function logOpenPreziCommunityPage() {
  return _log(18334, 'OpenPreziCommunityPage', 'OpenPreziCommunityPageWebJs');
}
export function logOpenPreziMarketplace() {
  return _log(18775, 'OpenPreziMarketplace', 'OpenPreziMarketplaceWebJs');
}
export function logOpenPreziRemote() {
  return _log(15414, 'OpenPreziRemote', 'OpenPreziRemoteWebJs');
}
export function logOpenPreziVideoCommunityPage() {
  return _log(18336, 'OpenPreziVideoCommunityPage', 'OpenPreziVideoCommunityPageWebJs');
}
export function logOpenPreziVideoDesktop(params) {
  return _log(22638, 'OpenPreziVideoDesktop', 'OpenPreziVideoDesktopWebJs', params);
}
export function logOpenPrivacyDialog(params) {
  return _log(24033, 'OpenPrivacyDialog', 'OpenPrivacyDialogWebJs', params);
}
export function logOpenProductSwitcher() {
  return _log(14385, 'OpenProductSwitcher', 'OpenProductSwitcherWebJs');
}
export function logOpenProfileSettings() {
  return _log(14388, 'OpenProfileSettings', 'OpenProfileSettingsWebJs');
}
export function logOpenReferralInviteLearnMore() {
  return _log(18350, 'OpenReferralInviteLearnMore', 'OpenReferralInviteLearnMoreWebJs');
}
export function logOpenReferralInvite(params) {
  return _log(30841, 'OpenReferralInvite', 'OpenReferralInviteWebJs', params);
}
export function logOpenSocialShare(params) {
  return _log(30890, 'OpenSocialShare', 'OpenSocialShareWebJs', params);
}
export function logOpenSupportPage() {
  return _log(14394, 'OpenSupportPage', 'OpenSupportPageWebJs');
}
export function logOpenSupportWidgetChat(params) {
  return _log(18682, 'OpenSupportWidgetChat', 'OpenSupportWidgetChatWebJs', params);
}
export function logOpenSupportWidgetMiniArticle(params) {
  return _log(18686, 'OpenSupportWidgetMiniArticle', 'OpenSupportWidgetMiniArticleWebJs', params);
}
export function logOpenSupportWidgetOriginalArticle(params) {
  return _log(18684, 'OpenSupportWidgetOriginalArticle', 'OpenSupportWidgetOriginalArticleWebJs', params);
}
export function logOpenSupportWidget(params) {
  return _log(18956, 'OpenSupportWidget', 'OpenSupportWidgetWebJs', params);
}
export function logOpenTeamMemberList(params) {
  return _log(23926, 'OpenTeamMemberList', 'OpenTeamMemberListWebJs', params);
}
export function logOpenTeamSettings(params) {
  return _log(14398, 'OpenTeamSettings', 'OpenTeamSettingsWebJs', params);
}
export function logOpenTemplateWizard(params) {
  return _log(32130, 'OpenTemplateWizard', 'OpenTemplateWizardWebJs', params);
}
export function logOpenToComment(params) {
  return _log(15433, 'OpenToComment', 'OpenToCommentWebJs', params);
}
export function logOpenToDownload(params) {
  return _log(32168, 'OpenToDownload', 'OpenToDownloadWebJs', params);
}
export function logOpenToPresent(params) {
  return _log(32398, 'OpenToPresent', 'OpenToPresentWebJs', params);
}
export function logOpenTrainingPage() {
  return _log(15489, 'OpenTrainingPage', 'OpenTrainingPageWebJs');
}
export function logOpenTranscript(params) {
  return _log(20280, 'OpenTranscript', 'OpenTranscriptWebJs', params);
}
export function logOpenTrash(params) {
  return _log(32132, 'OpenTrash', 'OpenTrashWebJs', params);
}
export function logOpenUnsupportedBrowserModal() {
  return _log(17733, 'OpenUnsupportedBrowserModal', 'OpenUnsupportedBrowserModalWebJs');
}
export function logOpenVatInputField() {
  return _log(27163, 'OpenVatInputField', 'OpenVatInputFieldWebJs');
}
export function logOpenViewLinkAnalytics(params) {
  return _log(15450, 'OpenViewLinkAnalytics', 'OpenViewLinkAnalyticsWebJs', params);
}
export function logOpenViewLinkDialog(params) {
  return _log(17190, 'OpenViewLinkDialog', 'OpenViewLinkDialogWebJs', params);
}
export function logOpenWhatsNewPage() {
  return _log(18338, 'OpenWhatsNewPage', 'OpenWhatsNewPageWebJs');
}
export function logOpenWholeCollection(params) {
  return _log(32134, 'OpenWholeCollection', 'OpenWholeCollectionWebJs', params);
}
export function logOpenWorkshopAndTraining() {
  return _log(14413, 'OpenWorkshopAndTraining', 'OpenWorkshopAndTrainingWebJs');
}
export function logOpenedAdminSettings(params) {
  return _log(16443, 'OpenedAdminSettings', 'OpenedAdminSettingsWebJs', params);
}
export function logOpenedBillingInfoModal() {
  return _log(17745, 'OpenedBillingInfoModal', 'OpenedBillingInfoModalWebJs');
}
export function logOpenedBrandkitTab(params) {
  return _log(24560, 'OpenedBrandkitTab', 'OpenedBrandkitTabWebJs', params);
}
export function logOpenedDemoModal() {
  return _log(22670, 'OpenedDemoModal', 'OpenedDemoModalWebJs');
}
export function logOpenedDocumentDashboardView(params) {
  return _log(32103, 'OpenedDocumentDashboardView', 'OpenedDocumentDashboardViewWebJs', params);
}
export function logOpenedDocumentRestrictedModal(params) {
  return _log(30109, 'OpenedDocumentRestrictedModal', 'OpenedDocumentRestrictedModalWebJs', params);
}
export function logOpenedInitiatorScreen(params) {
  return _log(29463, 'OpenedInitiatorScreen', 'OpenedInitiatorScreenWebJs', params);
}
export function logOpenedLogin(params) {
  return _log(22830, 'OpenedLogin', 'OpenedLoginWebJs', params);
}
export function logOpenedOutstandingBalanceModal() {
  return _log(29250, 'OpenedOutstandingBalanceModal', 'OpenedOutstandingBalanceModalWebJs');
}
export function logOpenedPaymentCardModal() {
  return _log(17751, 'OpenedPaymentCardModal', 'OpenedPaymentCardModalWebJs');
}
export function logOpenedPrivateEditingRestrictedModal(params) {
  return _log(29534, 'OpenedPrivateEditingRestrictedModal', 'OpenedPrivateEditingRestrictedModalWebJs', params);
}
export function logOpenedQuickCreateDashboardView(params) {
  return _log(32105, 'OpenedQuickCreateDashboardView', 'OpenedQuickCreateDashboardViewWebJs', params);
}
export function logOpenedSamlLogin(params) {
  return _log(23708, 'OpenedSamlLogin', 'OpenedSamlLoginWebJs', params);
}
export function logOpenedTeamInvitationModal(params) {
  return _log(26932, 'OpenedTeamInvitationModal', 'OpenedTeamInvitationModalWebJs', params);
}
export function logOpenedTemplateDashboardView(params) {
  return _log(32107, 'OpenedTemplateDashboardView', 'OpenedTemplateDashboardViewWebJs', params);
}
export function logOutstandingBalanceClickedOnChangePaymentMethod() {
  return _log(29252, 'OutstandingBalanceClickedOnChangePaymentMethod', 'OutstandingBalanceClickedOnChangePaymentMethodWebJs');
}
export function logOutstandingBalanceClickedOnRetryPayment() {
  return _log(29254, 'OutstandingBalanceClickedOnRetryPayment', 'OutstandingBalanceClickedOnRetryPaymentWebJs');
}
export function logPaidMarketingTrackingTriggered(params) {
  return _log(32356, 'PaidMarketingTrackingTriggered', 'PaidMarketingTrackingTriggeredWebJs', params);
}
export function logPassedOpenPreziWebglTwoCheck() {
  return _log(29516, 'PassedOpenPreziWebglTwoCheck', 'PassedOpenPreziWebglTwoCheckWebJs');
}
export function logPauseSubscription(params) {
  return _log(24594, 'PauseSubscription', 'PauseSubscriptionWebJs', params);
}
export function logPayForMtx(params) {
  return _log(27737, 'PayForMtx', 'PayForMtxWebJs', params);
}
export function logPickLibraryBasketOption(params) {
  return _log(17935, 'PickLibraryBasketOption', 'PickLibraryBasketOptionWebJs', params);
}
export function logPlayDesignToVideoOnboarding() {
  return _log(20525, 'PlayDesignToVideoOnboarding', 'PlayDesignToVideoOnboardingWebJs');
}
export function logPlayPrezi(params) {
  return _log(14421, 'PlayPrezi', 'PlayPreziWebJs', params);
}
export function logPlayReferralIntroVideo() {
  return _log(18352, 'PlayReferralIntroVideo', 'PlayReferralIntroVideoWebJs');
}
export function logPlayVideo() {
  return _log(15618, 'PlayVideo', 'PlayVideoWebJs');
}
export function logPresentInFullScreen(params) {
  return _log(32406, 'PresentInFullScreen', 'PresentInFullScreenWebJs', params);
}
export function logPreviewVideoTemplateWithInteractiveDemo(params) {
  return _log(32136, 'PreviewVideoTemplateWithInteractiveDemo', 'PreviewVideoTemplateWithInteractiveDemoWebJs', params);
}
export function logPreziEndScreenShowed(params) {
  return _log(15066, 'PreziEndScreenShowed', 'PreziEndScreenShowedWebJs', params);
}
export function logProgressVideoAd(params) {
  return _log(28673, 'ProgressVideoAd', 'ProgressVideoAdWebJs', params);
}
export function logProposedAiOutput(params) {
  return _log(31548, 'ProposedAiOutput', 'ProposedAiOutputWebJs', params);
}
export function logPublishEditingRestrictedPrezi(params) {
  return _log(29536, 'PublishEditingRestrictedPrezi', 'PublishEditingRestrictedPreziWebJs', params);
}
export function logPublishedBrandkit(params) {
  return _log(20423, 'PublishedBrandkit', 'PublishedBrandkitWebJs', params);
}
export function logPurchaseMtx(params) {
  return _log(27735, 'PurchaseMtx', 'PurchaseMtxWebJs', params);
}
export function logRateSupportWidgetChat(params) {
  return _log(18696, 'RateSupportWidgetChat', 'RateSupportWidgetChatWebJs', params);
}
export function logReceivedRateLimitError(params) {
  return _log(31752, 'ReceivedRateLimitError', 'ReceivedRateLimitErrorWebJs', params);
}
export function logRedirectLibraryToFallback(params) {
  return _log(17789, 'RedirectLibraryToFallback', 'RedirectLibraryToFallbackWebJs', params);
}
export function logReferralInviteEmailSent(params) {
  return _log(18354, 'ReferralInviteEmailSent', 'ReferralInviteEmailSentWebJs', params);
}
export function logRejectAllCookies(params) {
  return _log(24507, 'RejectAllCookies', 'RejectAllCookiesWebJs', params);
}
export function logRemoveAsAdmin(params) {
  return _log(14431, 'RemoveAsAdmin', 'RemoveAsAdminWebJs', params);
}
export function logRemoveDocumentFromFolder(params) {
  return _log(32138, 'RemoveDocumentFromFolder', 'RemoveDocumentFromFolderWebJs', params);
}
export function logRemoveFeaturesRestrictedPrezi(params) {
  return _log(30111, 'RemoveFeaturesRestrictedPrezi', 'RemoveFeaturesRestrictedPreziWebJs', params);
}
export function logRemoveFolderCollaborator(params) {
  return _log(30985, 'RemoveFolderCollaborator', 'RemoveFolderCollaboratorWebJs', params);
}
export function logRemoveGramFromFolder(params) {
  return _log(17318, 'RemoveGramFromFolder', 'RemoveGramFromFolderWebJs', params);
}
export function logRemoveItemFromMyLibrary(params) {
  return _log(17077, 'RemoveItemFromMyLibrary', 'RemoveItemFromMyLibraryWebJs', params);
}
export function logRemovePresentationFromFolder(params) {
  return _log(14438, 'RemovePresentationFromFolder', 'RemovePresentationFromFolderWebJs', params);
}
export function logRemoveTeamMember(params) {
  return _log(14442, 'RemoveTeamMember', 'RemoveTeamMemberWebJs', params);
}
export function logRenameGram(params) {
  return _log(17320, 'RenameGram', 'RenameGramWebJs', params);
}
export function logRenamedMyLibraryItem(params) {
  return _log(17073, 'RenamedMyLibraryItem', 'RenamedMyLibraryItemWebJs', params);
}
export function logRenewedSubscription(params) {
  return _log(32307, 'RenewedSubscription', 'RenewedSubscriptionWebJs', params);
}
export function logReportCreditsStatus(params) {
  return _log(32345, 'ReportCreditsStatus', 'ReportCreditsStatusWebJs', params);
}
export function logRequestDemo(params) {
  return _log(23292, 'RequestDemo', 'RequestDemoWebJs', params);
}
export function logRequestedBrowserNotificationsPermission() {
  return _log(14894, 'RequestedBrowserNotificationsPermission', 'RequestedBrowserNotificationsPermissionWebJs');
}
export function logResentTeamMemberInvitation(params) {
  return _log(14444, 'ResentTeamMemberInvitation', 'ResentTeamMemberInvitationWebJs', params);
}
export function logRestartPrezi(params) {
  return _log(14447, 'RestartPrezi', 'RestartPreziWebJs', params);
}
export function logRestoreDocument(params) {
  return _log(32140, 'RestoreDocument', 'RestoreDocumentWebJs', params);
}
export function logResubscribeExpiredLicense(params) {
  return _log(27862, 'ResubscribeExpiredLicense', 'ResubscribeExpiredLicenseWebJs', params);
}
export function logRetryAiMessageResponse(params) {
  return _log(31659, 'RetryAiMessageResponse', 'RetryAiMessageResponseWebJs', params);
}
export function logRetryDownloadAiAdditionalOutput(params) {
  return _log(32162, 'RetryDownloadAiAdditionalOutput', 'RetryDownloadAiAdditionalOutputWebJs', params);
}
export function logRetryOpenVideoApp() {
  return _log(16715, 'RetryOpenVideoApp', 'RetryOpenVideoAppWebJs');
}
export function logReusePaymentMethod(params) {
  return _log(27711, 'ReusePaymentMethod', 'ReusePaymentMethodWebJs', params);
}
export function logRevokedAccessToken(params) {
  return _log(29466, 'RevokedAccessToken', 'RevokedAccessTokenWebJs', params);
}
export function logSalesLeadUploadFailed(params) {
  return _log(24253, 'SalesLeadUploadFailed', 'SalesLeadUploadFailedWebJs', params);
}
export function logSamlLoggedInSuccess(params) {
  return _log(16978, 'SamlLoggedInSuccess', 'SamlLoggedInSuccessWebJs', params);
}
export function logSaveAllFrames(params) {
  return _log(17937, 'SaveAllFrames', 'SaveAllFramesWebJs', params);
}
export function logSaveBillingAddress(params) {
  return _log(17743, 'SaveBillingAddress', 'SaveBillingAddressWebJs', params);
}
export function logSaveBrandkit(params) {
  return _log(20425, 'SaveBrandkit', 'SaveBrandkitWebJs', params);
}
export function logSaveFrame(params) {
  return _log(32142, 'SaveFrame', 'SaveFrameWebJs', params);
}
export function logSavePaymentCard(params) {
  return _log(17749, 'SavePaymentCard', 'SavePaymentCardWebJs', params);
}
export function logSavePersonalVideoReferralInvite() {
  return _log(18368, 'SavePersonalVideoReferralInvite', 'SavePersonalVideoReferralInviteWebJs');
}
export function logSaveReferralInvitePersonalNote() {
  return _log(18360, 'SaveReferralInvitePersonalNote', 'SaveReferralInvitePersonalNoteWebJs');
}
export function logSaveSamlSettings(params) {
  return _log(16449, 'SaveSamlSettings', 'SaveSamlSettingsWebJs', params);
}
export function logSavedMyLibraryItem(params) {
  return _log(31374, 'SavedMyLibraryItem', 'SavedMyLibraryItemWebJs', params);
}
export function logScrollNotificationCenterMessages(params) {
  return _log(21994, 'ScrollNotificationCenterMessages', 'ScrollNotificationCenterMessagesWebJs', params);
}
export function logScrollWelcomeTemplates(params) {
  return _log(17807, 'ScrollWelcomeTemplates', 'ScrollWelcomeTemplatesWebJs', params);
}
export function logSearchContent(params) {
  return _log(17082, 'SearchContent', 'SearchContentWebJs', params);
}
export function logSearchMyDocuments(params) {
  return _log(32144, 'SearchMyDocuments', 'SearchMyDocumentsWebJs', params);
}
export function logSearchPresentation() {
  return _log(14463, 'SearchPresentation', 'SearchPresentationWebJs');
}
export function logSearchPresentations(params) {
  return _log(17084, 'SearchPresentations', 'SearchPresentationsWebJs', params);
}
export function logSearchPrezisClicked() {
  return _log(15074, 'SearchPrezisClicked', 'SearchPrezisClickedWebJs');
}
export function logSearchSupportWidgetKnowledgeBase(params) {
  return _log(18688, 'SearchSupportWidgetKnowledgeBase', 'SearchSupportWidgetKnowledgeBaseWebJs', params);
}
export function logSeeAllTemplates(params) {
  return _log(32146, 'SeeAllTemplates', 'SeeAllTemplatesWebJs', params);
}
export function logSeePathStepPreview(params) {
  return _log(14468, 'SeePathStepPreview', 'SeePathStepPreviewWebJs', params);
}
export function logSeekChapter(params) {
  return _log(22926, 'SeekChapter', 'SeekChapterWebJs', params);
}
export function logSelectAiOrDashboard(params) {
  return _log(30335, 'SelectAiOrDashboard', 'SelectAiOrDashboardWebJs', params);
}
export function logSelectAllProjectCard(params) {
  return _log(20844, 'SelectAllProjectCard', 'SelectAllProjectCardWebJs', params);
}
export function logSelectAudience(params) {
  return _log(31025, 'SelectAudience', 'SelectAudienceWebJs', params);
}
export function logSelectExportBackgroundSetting(params) {
  return _log(22194, 'SelectExportBackgroundSetting', 'SelectExportBackgroundSettingWebJs', params);
}
export function logSelectFileExportUpgradeOption(params) {
  return _log(32242, 'SelectFileExportUpgradeOption', 'SelectFileExportUpgradeOptionWebJs', params);
}
export function logSelectMoreProductsDropdown(params) {
  return _log(32148, 'SelectMoreProductsDropdown', 'SelectMoreProductsDropdownWebJs', params);
}
export function logSelectPlan(params) {
  return _log(30500, 'SelectPlan', 'SelectPlanWebJs', params);
}
export function logSelectPresentationForAnalyticsLink(params) {
  return _log(14470, 'SelectPresentationForAnalyticsLink', 'SelectPresentationForAnalyticsLinkWebJs', params);
}
export function logSelectStartFromTemplateOrPrompt(params) {
  return _log(27835, 'SelectStartFromTemplateOrPrompt', 'SelectStartFromTemplateOrPromptWebJs', params);
}
export function logSelectedUrgencyTime(params) {
  return _log(29951, 'SelectedUrgencyTime', 'SelectedUrgencyTimeWebJs', params);
}
export function logSelectedViewCreatingOptions() {
  return _log(20594, 'SelectedViewCreatingOptions', 'SelectedViewCreatingOptionsWebJs');
}
export function logSendReferralInviteSocial(params) {
  return _log(18358, 'SendReferralInviteSocial', 'SendReferralInviteSocialWebJs', params);
}
export function logSendTeamInvites(params) {
  return _log(28011, 'SendTeamInvites', 'SendTeamInvitesWebJs', params);
}
export function logSentAudienceType(params) {
  return _log(31027, 'SentAudienceType', 'SentAudienceTypeWebJs', params);
}
export function logSetPrivacy(params) {
  return _log(27963, 'SetPrivacy', 'SetPrivacyWebJs', params);
}
export function logSharePresentation(params) {
  return _log(17671, 'SharePresentation', 'SharePresentationWebJs', params);
}
export function logSharePublish(params) {
  return _log(17673, 'SharePublish', 'SharePublishWebJs', params);
}
export function logShowPagedTranscript(params) {
  return _log(29265, 'ShowPagedTranscript', 'ShowPagedTranscriptWebJs', params);
}
export function logShowPptInsertOptions(params) {
  return _log(14898, 'ShowPptInsertOptions', 'ShowPptInsertOptionsWebJs', params);
}
export function logShowQrCodePresenting(params) {
  return _log(31699, 'ShowQrCodePresenting', 'ShowQrCodePresentingWebJs', params);
}
export function logShowVideoWelcomeDialog() {
  return _log(15768, 'ShowVideoWelcomeDialog', 'ShowVideoWelcomeDialogWebJs');
}
export function logShowedEmailCapture(params) {
  return _log(15079, 'ShowedEmailCapture', 'ShowedEmailCaptureWebJs', params);
}
export function logShowedRotateOverlay() {
  return _log(29511, 'ShowedRotateOverlay', 'ShowedRotateOverlayWebJs');
}
export function logShownClassicToNextModal() {
  return _log(19584, 'ShownClassicToNextModal', 'ShownClassicToNextModalWebJs');
}
export function logShownClassicToNextOnboarding() {
  return _log(19586, 'ShownClassicToNextOnboarding', 'ShownClassicToNextOnboardingWebJs');
}
export function logShownDashboardOnboarding(params) {
  return _log(20598, 'ShownDashboardOnboarding', 'ShownDashboardOnboardingWebJs', params);
}
export function logSignUpWithSso(params) {
  return _log(26190, 'SignUpWithSso', 'SignUpWithSsoWebJs', params);
}
export function logSignupFlowFailure(params) {
  return _log(27713, 'SignupFlowFailure', 'SignupFlowFailureWebJs', params);
}
export function logSignupFlowSuccess(params) {
  return _log(27715, 'SignupFlowSuccess', 'SignupFlowSuccessWebJs', params);
}
export function logSignupWithIntegrationWarning(params) {
  return _log(29472, 'SignupWithIntegrationWarning', 'SignupWithIntegrationWarningWebJs', params);
}
export function logSignupWithIntegration(params) {
  return _log(29470, 'SignupWithIntegration', 'SignupWithIntegrationWebJs', params);
}
export function logSignupWithProvider(params) {
  return _log(22936, 'SignupWithProvider', 'SignupWithProviderWebJs', params);
}
export function logSkipAiChat(params) {
  return _log(31544, 'SkipAiChat', 'SkipAiChatWebJs', params);
}
export function logSkipAiPresentationContentFromAiLandingPage() {
  return _log(27873, 'SkipAiPresentationContentFromAiLandingPage', 'SkipAiPresentationContentFromAiLandingPageWebJs');
}
export function logSkipAiPresentationContentFromHomepage(params) {
  return _log(29452, 'SkipAiPresentationContentFromHomepage', 'SkipAiPresentationContentFromHomepageWebJs', params);
}
export function logSkipAiPresentationContentFromStudentPage(params) {
  return _log(30023, 'SkipAiPresentationContentFromStudentPage', 'SkipAiPresentationContentFromStudentPageWebJs', params);
}
export function logSkipCreateTeam(params) {
  return _log(32150, 'SkipCreateTeam', 'SkipCreateTeamWebJs', params);
}
export function logSkipDashboardOnboarding(params) {
  return _log(20600, 'SkipDashboardOnboarding', 'SkipDashboardOnboardingWebJs', params);
}
export function logSkipInviteTeamMember(params) {
  return _log(32152, 'SkipInviteTeamMember', 'SkipInviteTeamMemberWebJs', params);
}
export function logSkipVideoAd() {
  return _log(28679, 'SkipVideoAd', 'SkipVideoAdWebJs');
}
export function logSkipWelcomeScreen(params) {
  return _log(25389, 'SkipWelcomeScreen', 'SkipWelcomeScreenWebJs', params);
}
export function logSlotRenderEndedEvent() {
  return _log(29378, 'SlotRenderEndedEvent', 'SlotRenderEndedEventWebJs');
}
export function logSlotRenderStartedEvent() {
  return _log(29380, 'SlotRenderStartedEvent', 'SlotRenderStartedEventWebJs');
}
export function logSlotRequestedEvent() {
  return _log(29384, 'SlotRequestedEvent', 'SlotRequestedEventWebJs');
}
export function logSlotResponseReceivedEvent() {
  return _log(29382, 'SlotResponseReceivedEvent', 'SlotResponseReceivedEventWebJs');
}
export function logStartAiChat(params) {
  return _log(31540, 'StartAiChat', 'StartAiChatWebJs', params);
}
export function logStartFileExport(params) {
  return _log(32246, 'StartFileExport', 'StartFileExportWebJs', params);
}
export function logStartGeneratingAiOutput(params) {
  return _log(31550, 'StartGeneratingAiOutput', 'StartGeneratingAiOutputWebJs', params);
}
export function logStartSubscription() {
  return _log(27346, 'StartSubscription', 'StartSubscriptionWebJs');
}
export function logStartTeamCreationFromInvitations(params) {
  return _log(26928, 'StartTeamCreationFromInvitations', 'StartTeamCreationFromInvitationsWebJs', params);
}
export function logStartedExportingPdf(params) {
  return _log(31133, 'StartedExportingPdf', 'StartedExportingPdfWebJs', params);
}
export function logStartedSalesLeadUpload(params) {
  return _log(23966, 'StartedSalesLeadUpload', 'StartedSalesLeadUploadWebJs', params);
}
export function logStartedTrialAtReg(params) {
  return _log(30861, 'StartedTrialAtReg', 'StartedTrialAtRegWebJs', params);
}
export function logStartedUpgradeTrial(params) {
  return _log(30864, 'StartedUpgradeTrial', 'StartedUpgradeTrialWebJs', params);
}
export function logStoryBlockThumbnailClicked(params) {
  return _log(15099, 'StoryBlockThumbnailClicked', 'StoryBlockThumbnailClickedWebJs', params);
}
export function logSubmitCancelSubscriptionReason(params) {
  return _log(26942, 'SubmitCancelSubscriptionReason', 'SubmitCancelSubscriptionReasonWebJs', params);
}
export function logSubmitConsiderResubscribe(params) {
  return _log(26946, 'SubmitConsiderResubscribe', 'SubmitConsiderResubscribeWebJs', params);
}
export function logSubmitContactSalesForm(params) {
  return _log(24513, 'SubmitContactSalesForm', 'SubmitContactSalesFormWebJs', params);
}
export function logSubmitCreateTeam(params) {
  return _log(32154, 'SubmitCreateTeam', 'SubmitCreateTeamWebJs', params);
}
export function logSubmitInviteTeamMember(params) {
  return _log(32156, 'SubmitInviteTeamMember', 'SubmitInviteTeamMemberWebJs', params);
}
export function logSubmitPaymentInfoBuyNow(params) {
  return _log(25821, 'SubmitPaymentInfoBuyNow', 'SubmitPaymentInfoBuyNowWebJs', params);
}
export function logSubmitPaymentInfo() {
  return _log(14591, 'SubmitPaymentInfo', 'SubmitPaymentInfoWebJs');
}
export function logSubmitPaymentMethodDetails(params) {
  return _log(27717, 'SubmitPaymentMethodDetails', 'SubmitPaymentMethodDetailsWebJs', params);
}
export function logSubmitPaymentMethodSuccess(params) {
  return _log(27719, 'SubmitPaymentMethodSuccess', 'SubmitPaymentMethodSuccessWebJs', params);
}
export function logSubmitPersonalInfoBuyNow(params) {
  return _log(27321, 'SubmitPersonalInfoBuyNow', 'SubmitPersonalInfoBuyNowWebJs', params);
}
export function logSubmitPersonalInfo() {
  return _log(14593, 'SubmitPersonalInfo', 'SubmitPersonalInfoWebJs');
}
export function logSubmitSupportWidgetOfflineChatForm(params) {
  return _log(18694, 'SubmitSupportWidgetOfflineChatForm', 'SubmitSupportWidgetOfflineChatFormWebJs', params);
}
export function logSubmittedIntentSurveyAnswer(params) {
  return _log(25391, 'SubmittedIntentSurveyAnswer', 'SubmittedIntentSurveyAnswerWebJs', params);
}
export function logSubmittedSegmentationAnswer(params) {
  return _log(15897, 'SubmittedSegmentationAnswer', 'SubmittedSegmentationAnswerWebJs', params);
}
export function logSubmittedSegmentationOnSignupScreen(params) {
  return _log(24485, 'SubmittedSegmentationOnSignupScreen', 'SubmittedSegmentationOnSignupScreenWebJs', params);
}
export function logSubmittedSubSegmentationAnswer(params) {
  return _log(15895, 'SubmittedSubSegmentationAnswer', 'SubmittedSubSegmentationAnswerWebJs', params);
}
export function logSubmittedViewerIdentificationForm(params) {
  return _log(14502, 'SubmittedViewerIdentificationForm', 'SubmittedViewerIdentificationFormWebJs', params);
}
export function logSuccessfulPaymentBuyNow(params) {
  return _log(27470, 'SuccessfulPaymentBuyNow', 'SuccessfulPaymentBuyNowWebJs', params);
}
export function logSuccessfulStripeTransaction(params) {
  return _log(27721, 'SuccessfulStripeTransaction', 'SuccessfulStripeTransactionWebJs', params);
}
export function logSuggestedSearchTermsClicked() {
  return _log(15109, 'SuggestedSearchTermsClicked', 'SuggestedSearchTermsClickedWebJs');
}
export function logSupportWidgetChatServedByAgent(params) {
  return _log(18680, 'SupportWidgetChatServedByAgent', 'SupportWidgetChatServedByAgentWebJs', params);
}
export function logSwitchPresentationModeDesignVideoPreview(params) {
  return _log(22204, 'SwitchPresentationModeDesignVideoPreview', 'SwitchPresentationModeDesignVideoPreviewWebJs', params);
}
export function logSwitchToPreziClassic() {
  return _log(19588, 'SwitchToPreziClassic', 'SwitchToPreziClassicWebJs');
}
export function logSwitchToPreziPresent() {
  return _log(19590, 'SwitchToPreziPresent', 'SwitchToPreziPresentWebJs');
}
export function logSwitchedFrequencyOnBillingPage(params) {
  return _log(32322, 'SwitchedFrequencyOnBillingPage', 'SwitchedFrequencyOnBillingPageWebJs', params);
}
export function logTeamMemberInvitationFailed(params) {
  return _log(26935, 'TeamMemberInvitationFailed', 'TeamMemberInvitationFailedWebJs', params);
}
export function logTeamMemberInvitationSuccess(params) {
  return _log(26938, 'TeamMemberInvitationSuccess', 'TeamMemberInvitationSuccessWebJs', params);
}
export function logTeamUpgradeToUnlockEditingRestrictedPrezi(params) {
  return _log(29538, 'TeamUpgradeToUnlockEditingRestrictedPrezi', 'TeamUpgradeToUnlockEditingRestrictedPreziWebJs', params);
}
export function logTeaserContentClicked(params) {
  return _log(15107, 'TeaserContentClicked', 'TeaserContentClickedWebJs', params);
}
export function logTeaserContentHovered(params) {
  return _log(15122, 'TeaserContentHovered', 'TeaserContentHoveredWebJs', params);
}
export function logToggleAccountDropdown(params) {
  return _log(32158, 'ToggleAccountDropdown', 'ToggleAccountDropdownWebJs', params);
}
export function logTryWowDemo() {
  return _log(22087, 'TryWowDemo', 'TryWowDemoWebJs');
}
export function logTurnOffCamera() {
  return _log(22676, 'TurnOffCamera', 'TurnOffCameraWebJs');
}
export function logTurnOnCamera(params) {
  return _log(22730, 'TurnOnCamera', 'TurnOnCameraWebJs', params);
}
export function logUnlikePresentationPage(params) {
  return _log(15841, 'UnlikePresentationPage', 'UnlikePresentationPageWebJs', params);
}
export function logUnlikePublishPage(params) {
  return _log(17374, 'UnlikePublishPage', 'UnlikePublishPageWebJs', params);
}
export function logUnlockAiCreditLimit(params) {
  return _log(32160, 'UnlockAiCreditLimit', 'UnlockAiCreditLimitWebJs', params);
}
export function logUnpublishedBrandkit() {
  return _log(22497, 'UnpublishedBrandkit', 'UnpublishedBrandkitWebJs');
}
export function logUpdateBillingAddress(params) {
  return _log(17747, 'UpdateBillingAddress', 'UpdateBillingAddressWebJs', params);
}
export function logUpdateBrandkit(params) {
  return _log(22499, 'UpdateBrandkit', 'UpdateBrandkitWebJs', params);
}
export function logUpdateCollaborator(params) {
  return _log(30901, 'UpdateCollaborator', 'UpdateCollaboratorWebJs', params);
}
export function logUpdateContactSalesFormData(params) {
  return _log(23245, 'UpdateContactSalesFormData', 'UpdateContactSalesFormDataWebJs', params);
}
export function logUpdatePaymentCard(params) {
  return _log(17753, 'UpdatePaymentCard', 'UpdatePaymentCardWebJs', params);
}
export function logUpdatedBillingAddress(params) {
  return _log(17741, 'UpdatedBillingAddress', 'UpdatedBillingAddressWebJs', params);
}
export function logUpdatedOccupation(params) {
  return _log(30278, 'UpdatedOccupation', 'UpdatedOccupationWebJs', params);
}
export function logUpdatedPaymentCard(params) {
  return _log(17739, 'UpdatedPaymentCard', 'UpdatedPaymentCardWebJs', params);
}
export function logUpdatedSaml(params) {
  return _log(16457, 'UpdatedSaml', 'UpdatedSamlWebJs', params);
}
export function logUpgradeFromCta(params) {
  return _log(31617, 'UpgradeFromCta', 'UpgradeFromCtaWebJs', params);
}
export function logUpgradeFromMtxPaywall(params) {
  return _log(27739, 'UpgradeFromMtxPaywall', 'UpgradeFromMtxPaywallWebJs', params);
}
export function logUpgradeLicense(params) {
  return _log(20838, 'UpgradeLicense', 'UpgradeLicenseWebJs', params);
}
export function logUpgradeToTeam(params) {
  return _log(23866, 'UpgradeToTeam', 'UpgradeToTeamWebJs', params);
}
export function logUpgradeToUnlockEditingRestrictedPrezi(params) {
  return _log(29540, 'UpgradeToUnlockEditingRestrictedPrezi', 'UpgradeToUnlockEditingRestrictedPreziWebJs', params);
}
export function logUpgradeToUnlockRestrictedPrezi(params) {
  return _log(30113, 'UpgradeToUnlockRestrictedPrezi', 'UpgradeToUnlockRestrictedPreziWebJs', params);
}
export function logUpgradedfromPaidtoPaid(params) {
  return _log(31749, 'UpgradedfromPaidtoPaid', 'UpgradedfromPaidtoPaidWebJs', params);
}
export function logUploadBrandkitCustomFonts() {
  return _log(19543, 'UploadBrandkitCustomFonts', 'UploadBrandkitCustomFontsWebJs');
}
export function logUploadedBrandkitCustomFonts() {
  return _log(19545, 'UploadedBrandkitCustomFonts', 'UploadedBrandkitCustomFontsWebJs');
}
export function logUploadedSalesLead(params) {
  return _log(23968, 'UploadedSalesLead', 'UploadedSalesLeadWebJs', params);
}
export function logUseDeepLink(params) {
  return _log(14868, 'UseDeepLink', 'UseDeepLinkWebJs', params);
}
export function logUseWebTemplate(params) {
  return _log(15603, 'UseWebTemplate', 'UseWebTemplateWebJs', params);
}
export function logViewGramDownloadOptions(params) {
  return _log(17322, 'ViewGramDownloadOptions', 'ViewGramDownloadOptionsWebJs', params);
}
export function logViewPageSearchSubmit(params) {
  return _log(15131, 'ViewPageSearchSubmit', 'ViewPageSearchSubmitWebJs', params);
}
export function logViewTeamMemberList(params) {
  return _log(23924, 'ViewTeamMemberList', 'ViewTeamMemberListWebJs', params);
}
export function logVisitPricingPage(params) {
  return _log(15605, 'VisitPricingPage', 'VisitPricingPageWebJs', params);
}
export function logVisitProductPage(params) {
  return _log(15150, 'VisitProductPage', 'VisitProductPageWebJs', params);
}
export function logVisitProjectFromAnalytics(params) {
  return _log(24467, 'VisitProjectFromAnalytics', 'VisitProjectFromAnalyticsWebJs', params);
}
export function logVisitSignupPage(params) {
  return _log(17106, 'VisitSignupPage', 'VisitSignupPageWebJs', params);
}
export function logWelcomeAction(params) {
  return _log(17805, 'WelcomeAction', 'WelcomeActionWebJs', params);
}
export function logZoomIn(params) {
  return _log(14555, 'ZoomIn', 'ZoomInWebJs', params);
}
export function logZoomOut(params) {
  return _log(14561, 'ZoomOut', 'ZoomOutWebJs', params);
}